;$(function() {
    //개선 요건으로 차후 개발에 수정요청 예정
    // var $mTab = $('.m-best-tab');
    // var bestTabHtml = $mTab[0].outerHTML;
    // $mTab.remove();
    // $('.ranking__top .ranking__title-wrap').after(bestTabHtml);
    ////개선 요건으로 차후 개발에 수정요청 예정
    // BTOCSITE-77409 START
    var isClickSuperCategoryIdTodays = false;
    var superCategoryNameTodays;
    var isClickSuperCategoryIdSubscribe = false;
    var superCategoryNameSubscribe;
    var isClickSuperCategoryIdEmployee = false;
    var superCategoryNameEmployee;
    // BTOCSITE-77409 END
    var priceTemplate = '{{#each (item, idx) in optionList}}'+
                            '<option value="{{idx+1}}" data-minPrice="{{item.minPrice}}" data-maxPrice="{{item.maxPrice}}">{{item.text}}</option>' +
                        '{{/each}}';

    var specTemplate = '{{#each (item, idx) in optionList}}'+
                            '<option value="{{item.filterValueId}}">{{item.filterName}}</option>' +
                        '{{/each}}';

    var noResultTemplate = '<div class="ranking-no-data">' +
                                '{{#if rankingType == "multiple-products"}}' +
                                    '<p>조건에 맞는 제품 조합이 없습니다.<br>필터를 다시 설정해 주세요.</p>' +
                                '{{#else}}' +
                                    '<p>조건에 맞는 제품이 없습니다.<br>필터를 다시 설정해 주세요.</p>' +
                                '{{/if}}' +
                            '</div>';

    var opinionTempalte = '{{priceRangeText}}의<br class="mo-only"> 제품은 어떠세요?';

    var bottomRecommendTemplate = '{{#if categoryName}}' +
                                        '<a href="{{categoryUrlPath}}" class="btn-link">더욱 다양한 <span id="categoryName">{{categoryName}}</span> 제품을 살펴보세요</a>' +
                                  '{{/if}}' +
                                  '{{#if priceRangeText}}' +
                                        '<button type="button" class="btn-link" onclick=changePrice("{{rankingType}}");>{{priceRangeText}} 제품 더보기</button>' +
                                  '{{/if}}';

    var packageBottomRecommendTemplate = '{{#if categoryName}}' +
                                            '<button type="button" class="btn-link" onclick=changePackageCategory("{{categoryRecommendIdList}}");>{{categoryName}} 포함된 제품 조합 더보기</button>' +
                                         '{{/if}}' +
                                         '{{#if priceRangeText}}' +
                                            '<button type="button" class="btn-link" onclick=changePrice("{{rankingType}}");>{{priceRangeText}} 제품 조합 더보기</button>' +
                                         '{{/if}}';

    var packageOpinionTempalte = '{{#if priceRangeText}}' +
                                    '{{priceRangeText}}의<br class="mo-only"> 제품 조합은 어떠세요?</p>' +
                                 '{{/if}}' +
                                 '{{#if categoryName}}' +
                                    '{{categoryName}}<br class="mo-only"> 포함된 조합은 어떠세요?</p>' +
                                 '{{/if}}';

    var productTemplate = '{{#each (product, idx) in productList}}' +
                            '<div class="ranking__item" data-modelId="{{product.modelId}}" data-sku="{{product.sku}}" data-modelName="{{product.modelName}}" data-modelDisplayName="{{product.modelDisplayName}}"' +
                                        'data-obsOriginalPrice="{{product.obsOriginalPrice}}" data-obsMemberPrice="{{product.obsMemberPrice}}" data-obsSellingPrice="{{product.obsSellingPrice}}" ' +
                                        'data-obsDiscountPrice="{{product.obsDiscountPrice}}" data-obsCouponDiscountPrice="{{product.obsCouponDiscountPrice}}" data-modelStatusCode="{{product.modelStatusCode}}" data-mediumImageAddr="{{product.mediumImageAddr}}">' +
                                '<a href="{{product.modelUrlPath}}" class="item__link" data-contents="{{product.gaDataContents}}" data-ec-product="{{product.ecProductInfo}}" product-impression-display="false">' +
                                    '<div class="item__num"><img src="/kr/images/BRK/new/icon_ranking_view_num{{idx+1}}.png" alt="랭킹{{idx+1}}"></div>' +
                                    '<div class="item__badge">' +
                                        '<div class="prod_badge">' +
                                            '{{#if product.timeDealBadgeFlag == "Y"}}' +
                                                '<span class="badge_box time">타임딜</span>' +
                                            '{{/if}}' +
                                            '{{#if product.releaseBadgeFlag}}' +
                                                '<span class="badge_box release-date">{{product.releaseBadgeFlag}}</span>' +
                                            '{{/if}}' +
                                            '{{#if product.mltpPlcyBadgeFlag == "Y"}}' +
                                                '<span class="badge_box multi-item">다품목할인</span>' +
                                            '{{/if}}' +
                                        '</div>' +
                                    '</div>' +
                                    '<div class="item__image">' +
                                        '<span><img src="{{product.mediumImageAddr}}" alt=""></span>' +
                                    '</div>' +
                                    '{{#if product.lgecomOnlyFlag == "Y"}}' +
                                        '<div class="middle-badge-list">' +
                                            '<span class="badge-lge-only"><em class="blind">닷컴 ONLY</em></span>' +
                                        '</div>' +
                                    '{{/if}}' +
                                    '<div class="item__info">' +
                                        '<div class = "item__top">'+
                                            '<div class="item__name">' +
                                                    '<span class="main-title">' +
                                                        '<span class="main"><span class="blind">제품명</span>{{#raw product.modelDisplayName}}</span>' +
                                                        '<span class="sub-text-new">' +
                                                            '{{#if product.keywdNmA}}<em class="sub"><span class="blind">제품정보</span>{{product.keywdNmA}}</em>{{/if}}' +
                                                            '{{#if product.keywdNmB}}<em class="sub">{{product.keywdNmB}}</em>{{/if}}' +
                                                        '</span>' +
                                                    '</span>' +
                                            '</div>' +
                                            '<div class="item__model-wrap">' +
                                                '<span class="item__sku"><span class="blind">모델명</span>{{product.modelName}}</span>' +
                                                '{{#if product.specText}}' +
                                                    '<span class="item__option"><span class="blind">제품옵션</span>{{product.specText}}</span>' +
                                                '{{/if}}' +
                                            '</div>' +
                                        '</div>' +
                                        '<div class="item__bottom">' +
                                            '<div class="item__discount-wrap">' +
                                                '{{#if product.memberDiscountRate && product.memberDiscountRate >= 5}}' +
                                                    '<span class="item__discount__rate"><span class="blind">할인율</span>{{product.memberDiscountRate}}%</span>' +
                                                '{{/if}}' +
                                                    '<span class="item__price item__price--mem"><strong class="item__number"><span class="blind">할인 전 가격</span>{{vcui.comma(product.obsSellingPrice)}}</strong>원</span>' +
                                            '</div>' +
                                            '{{#if empYn=="Y" && product.lgeSellPrice > 0 && product.lgeSellPrice < product.obsSellingPrice}}' +
                                                '<div class="item__price-wrap emp-price">' +
                                                    '<span class="item__tit">임직원할인가</span>' +
                                                    '<span class="item__price item__price--current"><strong class="item__number">{{vcui.comma(product.lgeSellPrice)}}</strong>원</span>' +
                                                '</div>' +
                                                '{{#if downTimeYn != "Y"}}' +
                                                    '{{#if product.empMaxBenefitPrice > 0 && product.empMaxBenefitPrice < product.lgeSellPrice}}' +
                                                        '<div class="item__price-wrap">' +
                                                            '<span class="item__tit">최대혜택가</span>' +
                                                            '<span class="item__price item__price--current"><strong class="item__number">{{vcui.comma(product.empMaxBenefitPrice)}}</strong>원</span>' +
                                                        '</div>' +
                                                    '{{/if}}' +
                                                '{{/if}}' +
                                            '{{#else}}' +
                                                '{{#if downTimeYn != "Y"}}' +
                                                    '{{#if product.maxBenefitPrice < product.obsSellingPrice}}' +
                                                        '<div class="item__price-wrap">' +
                                                            '<span class="item__tit">최대혜택가</span>' +
                                                            '<span class="item__price item__price--current"><strong class="item__number">{{vcui.comma(product.maxBenefitPrice)}}</strong>원</span>' +
                                                        '</div>' +
                                                    '{{/if}}' +
                                                '{{/if}}' +
                                            '{{/if}}' +
                                        '</div>' +
                                    '</div>' +
                                '</a>' +
                            '</div>' +
                          '{{/each}}';

    var packageProductTemplate = '{{#if categoryName}}<p class="tit-cate">{{categoryName}}</p>{{/if}}' +
                                 '{{#each (packageRanking, idx) in multipleBestRankingList}}' +
                                    '<div class="ranking__item--package-wrap">' +
                                            '<article class="ranking__price-flag">' +
                                                '<div class="item__num"><img src="/kr/images/BRK/new/icon_ranking_view_num{{idx+1}}.png" alt="랭킹{{idx+1}}"></div>' +
                                                '{{#if packageRanking.mtplBenefitPrice > 0}}' +
                                                '<span class="flag-tit">다품목 혜택</span>' +
                                                '<a href="#none" data-url="/benefits/exhibitions/detail-{{packageRanking.mltpPlanEventId}}" onClick="goToExhibitDetail({{idx + 1}}, \'{{packageRanking.mltpPlanEventId}}\');" tabindex="{{idx}}" class="flag-btn">함께 구매시 <strong>{{vcui.comma(packageRanking.mtplBenefitPrice)}}</strong>원 추가 할인</a>' +
                                                '{{/if}}' +
                                            '</article>' +
                                        '<div class="ranking__item--package" data-orderId="{{packageRanking.orderId}}">' +
                                            '{{#each (product, idx2) in packageRanking.productList}}' +
                                                '<div class="ranking__item" data-modelId="{{product.modelId}}" data-sku="{{product.sku}}" data-modelName="{{product.modelName}}" data-modelDisplayName="{{product.modelDisplayName}}"' +
                                                     'data-obsOriginalPrice="{{product.obsOriginalPrice}}" data-obsMemberPrice="{{product.obsMemberPrice}}" data-obsSellingPrice="{{product.obsSellingPrice}}" data-obsDiscountPrice="{{product.obsDiscountPrice}}" ' +
                                                     'data-obsCouponDiscountPrice="{{product.obsCouponDiscountPrice}}" data-modelStatusCode="{{product.modelStatusCode}}" data-mediumImageAddr="{{product.mediumImageAddr}}">' +
                                                    '<a href="{{product.modelUrlPath}}" class="item__link" data-contents="{{product.gaDataContents}}" data-ec-product="{{product.ecProductInfo}}" product-impression-display="false">' +
                                                        '<div class="item__badge">' +
                                                            '<div class="prod_badge">' +
                                                                '{{#if product.timeDealBadgeFlag == "Y"}}' +
                                                                    '<span class="badge_box time">타임딜</span>' +
                                                                '{{/if}}' +
                                                                '{{#if product.releaseBadgeFlag}}' +
                                                                    '<span class="badge_box release-date">{{product.releaseBadgeFlag}}</span>' +
                                                                '{{/if}}' +
                                                                '{{#if product.mltpPlcyBadgeFlag == "Y"}}' +
                                                                    '<span class="badge_box multi-item">다품목할인</span>' +
                                                                '{{/if}}' +
                                                            '</div>' +
                                                        '</div>' +
                                                        '<div class="item__image">' +
                                                            '<span><img src="{{product.mediumImageAddr}}" alt=""></span>' +
                                                            '{{#if product.lgecomOnlyFlag == "Y"}}' +
                                                                '<em class="badge lge-only"><span class="blind">닷컴 ONLY</span></em>' +
                                                            '{{/if}}' +
                                                        '</div>' +
                                                        '<div class="item__info">' +
                                                            '<div class="item__name">' +
                                                                '<span class="main-title">' +
                                                                    '<span class="main"><span class="blind">제품명</span>{{#raw product.modelDisplayName}}</span>' +
                                                                    '<span class="sub-text-new">' +
	                                                                    '{{#if product.keywdNmA}}<em class="sub"><span class="blind">제품정보</span>{{product.keywdNmA}}</em>{{/if}}' +
	                                                                	'{{#if product.keywdNmB}}<em class="sub">{{product.keywdNmB}}</em>{{/if}}' +
                                                                    '</span>' +
                                                                '</span>' +
                                                            '</div>' +
                                                            '<div class="item__model-wrap">' +
                                                                '<span class="item__sku"><span class="blind">모델명</span>{{product.modelName}}</span>' +
                                                                    '{{#if product.specText}}' +
                                                                        '<span class="item__option"><span class="blind">제품옵션</span>{{product.specText}}</span>' +
                                                                    '{{/if}}' +
                                                            '</div>' +
                                                            '<div class="item__bottom">' +
                                                                '<div class="item__discount-wrap">' +
                                                                	'{{#if product.memberDiscountRate && product.memberDiscountRate >= 5}}' +
                                                                        '<span class="item__discount__rate"><span class="blind">할인율</span>{{product.memberDiscountRate}}%</span>' +
                                                                    '{{/if}}' +
                                                                        '<span class="item__price item__price--mem"><strong class="item__number"><span class="blind">할인 전 가격</span>{{vcui.comma(product.obsSellingPrice)}}</strong>원</span>' +
                                                                '</div>' +
                                                                '{{#if downTimeYn != "Y"}}' +
                                                                    '{{#if product.maxBenefitPrice < product.obsSellingPrice}}' +
                                                                        '<div class="item__price-wrap">' +
                                                                            '<span class="item__tit">최대혜택가</span>' +
                                                                            '<span class="item__price item__price--current"><strong class="item__number">{{vcui.comma(product.maxBenefitPrice)}}</strong>원</span>' +
                                                                        '</div>' +
                                                                    '{{/if}}' +
                                                                '{{/if}}' +
                                                            '</div>' +
                                                        '</div>' +
                                                    '</a>' +
                                                    '{{#if product.crYn == "Y"}}' +
                                                        '<div class="ranking__item__product-benefit">' +
                                                            '<a class="btn-link" href="{{product.modelUrlPath}}?dpType=careTab" product-impression-display="true">다품목 제품 구독하기</a>' +
                                                        '</div>' +
                                                    '{{/if}}' +
                                                '</div>' +
                                            '{{/each}}' +
                                        '</div>' +
                                    '</div>' +
                                '{{/each}}';

    var subscribeProductTemplate = '{{#each (product, idx) in productList}}' +
                                        '<div class="ranking__item item_subscribe" data-modelId="{{product.modelId}}" data-sku="{{product.sku}}" data-modelName="{{product.modelName}}" data-modelDisplayName="{{product.modelDisplayName}}"' +
                                            'data-obsOriginalPrice="{{product.obsOriginalPrice}}" data-obsMemberPrice="{{product.obsMemberPrice}}" data-obsSellingPrice="{{product.obsSellingPrice}}" ' +
                                            'data-obsDiscountPrice="{{product.obsDiscountPrice}}" data-obsCouponDiscountPrice="{{product.obsCouponDiscountPrice}}" data-modelStatusCode="{{product.modelStatusCode}}" data-mediumImageAddr="{{product.mediumImageAddr}}">' +
                                        '<a href="{{product.modelUrlPath}}" class="item__link" data-contents="{{product.gaDataContents}}" data-ec-product="{{product.ecProductInfo}}" product-impression-display="false">' +
                                            '<div class="item__num"><img src="/kr/images/BRK/new/icon_ranking_view_num{{idx+1}}.png" alt="랭킹{{idx+1}}"></div>' +
                                            '<div class="item__badge">' +
                                                '<div class="prod_badge">' +
                                                    '{{#if product.releaseBadgeFlag}}' +
                                                        '<span class="badge_box release-date">{{product.releaseBadgeFlag}}</span>' +
                                                    '{{/if}}' +
                                                    '{{#if product.crYn == "Y"}}' +
                                                        '<span class="badge_box multi-item">다품목할인</span>' +
                                                    '{{/if}}' +
                                                '</div>' +
                                            '</div>' +
                                            '<div class="item__image">' +
                                                '<span><img src="{{product.mediumImageAddr}}" alt=""></span>' +
                                            '</div>' +
                                            '{{#if product.lgecomOnlyFlag == "Y" || product.firstEmblemInfo}}' + 
                                            '<div class="middle-badge-list">' +
                                                '{{#if product.lgecomOnlyFlag == "Y"}}' +
                                                    '<span class="badge-lge-only"><em class="blind">닷컴 ONLY</em></span>' +
                                                '{{/if}}' +
                                                '{{#if product.firstEmblemInfo}}' +
                                                    '<span class="{{product.firstEmblemInfo.className}}" style="display:none;"><em class="blind">{{product.firstEmblemInfo.name}}</em></span>' +
                                                '{{/if}}' +
                                                '{{#if product.lgecomOnlyFlag != "Y" && product.secondEmblemInfo}}' +
                                                    '<span class="{{product.secondEmblemInfo.className}}" style="display:none;"><em class="blind">{{product.secondEmblemInfo.name}}</em></span>' +
                                                '{{/if}}' +
                                            '</div>' +
                                            '{{/if}}' +
                                            '<div class="item__info">' +
                                                '<div class="item__top">' +
                                                    '<div class="item__name">' +
                                                        '<span class="main-title">' +
                                                            '<span class="main"><span class="blind">제품명</span>{{#raw product.modelDisplayName}}</span>' +
                                                            '<span class="sub-text-new">' +
                                                                '{{#if product.keywdNmA}}<em class="sub"><span class="blind">제품정보</span>{{product.keywdNmA}}</em>{{/if}}' +
                                                                '{{#if product.keywdNmB}}<em class="sub">{{product.keywdNmB}}</em>{{/if}}' +
                                                            '</span>' +
                                                        '</span>' +
                                                    '</div>' +
                                                    '<div class="item__model-wrap">' +
                                                        '<span class="item__sku"><span class="blind">모델명</span>{{product.modelName}}</span>' +
                                                        '{{#if product.specText}}' +
                                                            '<span class="item__option"><span class="blind">제품옵션</span>{{product.specText}}</span>' +
                                                        '{{/if}}' +
                                                    '</div>' +
                                                '</div>' +
                                                '<div class="item__bottom">' +
                                                    '<div class="item__discount-wrap">' +
                                                        '<span class="item__price item__price--mem"><span class="blind">할인 전 가격</span>월 <strong class="item__number">{{vcui.comma(product.obsSellingPrice)}}</strong>원</span>' +
                                                        '<em class="item__desc">{{product.productPriceDesc}}</em>' +
                                                    '</div>' +
                                                    '{{#if empYn == "Y" && product.lgeSellPrice > 0}}' +
                                                        '<div class="item__price-wrap emp-price">' +
                                                            '<span class="item__tit">임직원할인가</span>' +
                                                            '<span class="item__price item__price--current">월 <strong class="item__number">{{vcui.comma(product.lgeSellPrice)}}</strong>원</span>' +
                                                        '</div>' +
                                                        '<div class="item__price-wrap">' +
                                                            '<span class="item__tit">최대혜택가</span>' +
                                                            '<span class="item__price item__price--current">월 <strong class="item__number">{{vcui.comma(product.empMaxBenefitPrice)}}</strong>원</span>' +
                                                        '</div>' +
                                                    '{{#else}}' +
                                                        '{{#if product.maxBenefitPrice < product.obsSellingPrice}}' +
                                                            '<div class="item__price-wrap">' +
                                                                '<span class="item__tit">최대혜택가</span>' +
                                                                '<span class="item__price item__price--current">월 <strong class="item__number">{{vcui.comma(product.maxBenefitPrice)}}</strong>원</span>'+
                                                            '</div>' +
                                                        '{{/if}}' +
                                                    '{{/if}}' +
                                                '</div>' +
                                            '</div>' +
                                        '</a>' +
                                        '</div>' +
                                  '{{/each}}';

    var subCategoryTemplate =   '{{#each (category, idx) in categoryList}}' +
                                '<span class="rdo-wrap btn-type" {{#if viewFlag == "N" }}style = "display:none" {{/if}}>' +
                                    '<input type="radio" id="{{categorySeq}}-{{idx+1}}" name="{{rankingType}}Category" data-categoryid ="{{category.categoryId}}" data-categoryname ="{{category.categoryName}}" data-category-url-path="{{category.categoryUrlPath}}">'+  // BTOCSITE-74005
                                    '<label for="{{categorySeq}}-{{idx+1}}">{{category.categoryName}}</label>'+
                                '</span>'+
                                '{{/each}}';

    var bestRanking = {
        variable: {
            isHistoryBack : false,
            currentRankingType : '',
            currentCategoryId : '',
            selectedPackageCategory : [],
            tooltip : [{id:"todays", title : "오늘의 랭킹", desc : "최근 30일간 LGE.COM과 베스트샵에서 판매된 제품의 구매,조회 등의 데이터를 기반으로 랭킹을 제공합니다."}
                     , {id:"multiple-products", title : "혼수/이사 인기 패키지", desc : "최근 30일간 베스트샵에서 혼수/이사 등을 목적으로 구매한 다품조합 랭킹을 제공합니다."}
                     , {id:"present", title: "추천 선물", desc : "최근 30일간 베스트샵에서 판매된 제품 중 70만원 미만 제품의 구매,조회 등의 데이터를 기반으로 랭킹을 제공합니다."}
                     , {id:"subscribe", title: "가전 구독 랭킹", desc : "최근 30일간 LGE.COM에서 구독한 제품의 구매, 조회 등의 데이터를 기반으로 랭킹을 제공합니다."}
                     , {id:"employee", title: "임직원 랭킹", desc : "LG전자 임직원님들께서 최근 30일간 LGE.COM에서 구매 및 조회한 데이터를 기반으로 랭킹을 제공합니다."}],
            categorySpecName :
                                [{categoryId : "CT50000025", categoryName : "TV", specName : "화면크기"}
                               , {categoryId : "CT50000046", categoryName : "노트북", specName : "화면크기"}
                               , {categoryId : "CT50000055", categoryName : "모니터", specName : "화면크기"}
                               , {categoryId : "CT50000065", categoryName : "냉장고", specName : "용량"}
                               , {categoryId : "CT50000072", categoryName : "김치냉장고", specName : "용량"}
                               , {categoryId : "CT50000101", categoryName : "세탁기", specName : "용량"}
                               , {categoryId : "CT50000106", categoryName : "의류관리기", specName : "용량"}
                               , {categoryId : "CT50000107", categoryName : "의류건조기", specName : "용량"}
                               , {categoryId : "CT50000110", categoryName : "워시타워", specName : "세탁 용량"}
                               , {categoryId : "CT50000111", categoryName : "청소기", specName : "타입"}
                               , {categoryId : "CT50000131", categoryName : "에어컨", specName : "유형"}
                               , {categoryId : "CT50000143", categoryName : "공기청정기", specName : "공기청정면적"}
                               , {categoryId : "CT50019018", categoryName : "광파오븐/전자레인지", specName : "용량"}
                               , {categoryId : "CT50000076", categoryName : "전기레인지", specName : "유형"}
                               , {categoryId : "CT50000086", categoryName : "식기세척기", specName : "용량"}
                               , {categoryId : "CT50000142", categoryName : "제습기", specName : "제습능력"}
                               , {categoryId : "CT50115000", categoryName : "와인셀러", specName : "최대보관병수"}
                               , {categoryId : "CT50000036", categoryName : "오디오/비디오", specName : "라인업"}
                               , {categoryId : "CT50073000", categoryName : "컨버터블 패키지", specName : "에너지효율"}
                               , {categoryId : "CT50000139", categoryName : "가습기", specName : "가습량"}
                               , {categoryId : "CT50000094", categoryName : "정수기", specName : "분류"}
                               , {categoryId : "CT50000032", categoryName : "프로젝터", specName : "해상도"}
                               , {categoryId : "CT50000086", categoryName : "식기세척기", specName : "용량"}
                               , {categoryId : "CT50000175", categoryName : "정수기", specName : "분류"}
                               , {categoryId : "CT50238002", categoryName : "TV", specName : "화면크기"}
                               , {categoryId : "CT50178000", categoryName : "냉장고", specName : "용량"}
                               , {categoryId : "CT50203000", categoryName : "김치냉장고", specName : "용량"}
                               , {categoryId : "CT50000177", categoryName : "공기청정기", specName : "공기청정면적"}
                               , {categoryId : "CT50080000", categoryName : "에어컨", specName : "유형"}
                               , {categoryId : "CT50000180", categoryName : "전기레인지", specName : "유형"}
                               , {categoryId : "CT50000181", categoryName : "식기세척기", specName : "용량"}
                               , {categoryId : "CT50166000", categoryName : "워시타워", specName : "세탁 용량"}
                               , {categoryId : "CT50136000", categoryName : "세탁기", specName : "용량"}
                               , {categoryId : "CT50000178", categoryName : "의류건조기", specName : "용량"}
                               , {categoryId : "CT50000179", categoryName : "의류관리기", specName : "용량"}
                               , {categoryId : "CT50150000", categoryName : "청소기", specName : "타입"}
                               , {categoryId : "CT50000182", categoryName : "안마의자", specName : "유형"}
                               ],
        },
        init: function(){
            var self = this;
            self.settings();
            self.bindEvents();

            var data = history.state;
            if(data){
                self.variable.isHistoryBack = true;
                self.getHistoryState(data);

                if ($("#multiple-productsPrice option").length == 1) {
                    bestRanking.retrievePriceRangeList('multiple-products', '');
                } else if ($("#presentPrice option").length == 1) {
                    bestRanking.retrievePriceRangeList('present', '');
                }

            } else {
                self.setPriceFilter();
            }

            var inputId = null;
            var $tab2Input = $('.filter-tab-list .rdo-flex .rdo-wrap input');
            $tab2Input.prop('disabled',false);

            //1뎁스 탭 활성화 ID
            function getTab1ActiveId(){
                return $('#bestRankingTab .tabs li.on').attr('id');
            }
            
            //카테고리탭 활성화 정렬
            function leftPosCate($list){
                if($list.find('input:checked').length==1){
                     $list.scrollLeft(0);
                     var initLeft = $list.offset().left;
                     var left = $list.find('input:checked').parent().offset().left - (window.innerWidth < 768 ? 26 : 70); //수정체크
                     $list.scrollLeft(left-initLeft);
                 }
            }

            //2뎁스 탭 빠른 선택 방지
            $tab2Input.on('change',function(e){
                clearTimeout(inputId);
                $('.filter-tab-wrap').parent().css('height','auto');
                // [S] BTOCSITE-77409 [웹앱 접근성 개선활동] 전시_베스트랭킹
                // $tab2Input.prop('disabled',true);
                $(e.target).off('keydown.tab2').on('keydown.tab2', function(e) {
                    e.preventDefault();
                });
                // [E] BTOCSITE-77409 [웹앱 접근성 개선활동] 전시_베스트랭킹
                inputId = setTimeout(function(){
                    $('.filter-tab-wrap').parent().css('height', $('.filter-tab-wrap').outerHeight());
                    // $tab2Input.prop('disabled',false);
                    $(e.target).off('keydown.tab2') // BTOCSITE-77409 [웹앱 접근성 개선활동] 전시_베스트랭킹
                },600);
            });

            //탭 요소 활성화 싱크
            $(window).on('setTabSync',function(e, trigger){
                $(window).trigger('stickyTabActive');
            }).trigger('setTabSync');



            //2뎁스 탭 현재 탭 left 위치 활성화
            $(window).on('stickyTabActive',function(){
                setTimeout(function(){
                    //2뎁스
                    if($('#'+getTab1ActiveId()+'SuperCategory').length == 1){
                        leftPosCate($('#'+getTab1ActiveId()+'SuperCategory'));
                    }
                    //3뎁스
                    if($('#'+getTab1ActiveId()+'Category').length == 1 ){
                        leftPosCate($('#'+getTab1ActiveId()+'Category'));
                    }
                });
            });

            $(window).on('resizeend',function(){
                $(window).trigger('setTabSync');
            });

            //1뎁스 탭 클릭 이벤트
            $('#bestRankingTab .tabs li a').on('click',function(){
                $(window).trigger('setTabSync');
            });

            //페이지 최초 진입시 뒤로가기 했을때 2번 클릭해야 뒤로가기됨 수정
            $(window).on('pagehide',function(){
                sessionStorage.removeItem('onceBestRankingDetail');
            });
            //BTOCSITE-93890
            var $filterTabList = $('.ranking__top .filter-tab-list');
            $filterTabList.eq(2).length == 1 && $filterTabList.eq(2).attr('id','multiple-products_category_content');
            $filterTabList.eq(3).length == 1 && $filterTabList.eq(3).attr('id','single-person_category_content');
        },
        settings: function(){
            var self = this;
            self.setDefaultTab();
            self.setDefaultCategory();
            self.$brandMain = $('.best-ranking');
            self.setTab();
            self.setToolTip();
        },
        setTab:function(){
            var self = this;
            var $stcikyTabWrap = self.$brandMain.find('.ui_sticky_wrap');
            var $stcikyTab = self.$brandMain.find('.ui_stickyTab');
            var idx = $stcikyTab.attr('data-selected-index') || 0;
            var $filterTabWrap = self.$brandMain.find('.filter-tab-wrap');
            var $filterTab = $filterTabWrap.find('.forms');
            var $filterView = $filterTabWrap.find('.filter-view');
            var $filterClose = $filterTabWrap.find('.filter-close');
            var $sub = $('.sub-renew-nav-wrap');
            var $header = $('.header');
            var currentIdx = idx;
            $filterTabWrap.wrap('<div>');
            var $filterTabWrapParent = $filterTabWrap.parent();
            $filterClose.text('필터 열기');
            var noScroll = false;
            $(window).on('resize', function(){
                $(window).trigger('scroll');
            }).on('resizeend', function(){
                setFilterH();
                setBtnCate();
            }).on('scroll', function(){
                if(noScroll == true){return;}
                if(window.innerWidth < 768){
                    //MO일때
                    //타이틀 헤더 무반응 구간 설정
                    var startH = $filterTabWrapParent.offset().top-5;
                    var endH = $filterTabWrapParent.offset().top + $filterTabWrap.outerHeight();
                    if($(window).scrollTop() < startH || endH < $(window).scrollTop()){
                        $header.removeClass('hideFix');
                        $sub.removeClass('hideFix');
                    }else{
                        $header.addClass('hideFix');
                        $sub.addClass('hideFix');
                    }

                    if( $filterTabWrapParent.offset().top < $(window).scrollTop() ){
                        if($header.hasClass('hide') || $header.hasClass('hideFix')){
                            $filterTabWrap.addClass('up').removeClass('down');
                        }else{
                            $filterTabWrap.removeClass('up').addClass('down');
                        }
                    }else{
                        $filterTabWrap.removeClass('up').removeClass('down');
                    }
                }else{
                    //PC일때
                    var $stickyWrap = $('.ui_sticky_wrap');
                    if( $filterTabWrapParent.offset().top - $stickyWrap.height() <= $(window).scrollTop()  ){
                        $filterTabWrap.addClass('up').removeClass('down')
                    }else{
                        $filterTabWrap.removeClass('up').removeClass('down');
                    }
                    if($stickyWrap.parent().offset().top > $(window).scrollTop()){
                        $stickyWrap.removeAttr('style');
                    }
                }
                $filterTabWrapParent.css('height', $filterTabWrap.outerHeight());
            }).load(function(){
                $('.subRenewWrap').on('change',function(e, trigger){
                    if (trigger === false || noScroll) return; // BTOCSITE-63854 [베스트랭킹] 오늘의랭킹으로 뒤로가기 시 Layout Shift 발생
                    
                    if($(e.target).hasClass('ui_selectbox') || $(e.target).attr('type') == 'radio'){
                        if(window.innerWidth < 768){
                            noScroll = true;
                            if( $filterTabWrapParent.offset().top < $(window).scrollTop() ){
                                $filterTabWrap.addClass('up').removeClass('down');
                            }
                            $header.addClass('hideFix');
                            $sub.addClass('hideFix');
                            $filterTabWrapParent.css('height', $filterTabWrap.outerHeight());
                            $('html, body').clearQueue().stop().animate({scrollTop: $filterTabWrapParent.offset().top},300,function(){
                                noScroll = false;
                                $(window).trigger('scroll').trigger('stickyTabActive');
                            });
                        }else{
                             $('html, body').clearQueue().stop().animate({scrollTop: 0},300,function(){
                                $(window).trigger('stickyTabActive')
                            });
                        }
                    }
                });
                //init
                $stcikyTab.vcStickyTab('instance').offChange = true;
                var data = history.state;
                if(data){
                    self.variable.isHistoryBack = true;
                }
                $stcikyTab.find('li').eq(idx).find('a').trigger('click');

                $(window).trigger('scroll');

                //BTOCSITE-45006
                $('.slide-wrap').css('visibility','visible');

                //MO 필터탭 모달 높이값 설정
                $('select').on('selectboxopen', function(e,data){
                    setFilterH();
                    $('.cate-open').removeClass('cate-open')
                });
                $('.btn-cate').on('click',function(){
                    setFilterH();
                })
                //MO 필터탭 셀렉트 모달 배경클릭 닫기 방지


                // $('.ui-selectbox-wrap').each(function(){
                //     $(this).append('<div class="screen" style="position:fixed;width:100%;height:100%;top:0;left:0;z-index:88;"></div>');
                // });


                //카테고리탭 좌우 버튼
                $('.ranking__top').on('click','.filter-tab-wrap .btn-arrow.next',function(){
                    cateLeftMove($(this));
                }).on('click','.filter-tab-wrap .btn-arrow.prev',function(){
                    cateLeftMove($(this))
                });
                function cateLeftMove($list){
                    var dirNum = $list.hasClass('next')? 1 : -1;
                    $list = $list.parent();
                    var $rdoFlex = $list.find('.rdo-flex');
                    var $rdoWrap = $list.find('.rdo-flex .rdo-wrap');
                    var moveX = $rdoFlex.scrollLeft() + $rdoFlex.width() * dirNum;
                    var left = null;
                    var leftArr = [];
                    var addLeft = 0;
                    for(var i=0; i <  $rdoWrap.length; i++){
                        leftArr.push(addLeft);
                        if(i <  $rdoWrap.length-1 ){
                            addLeft += $rdoWrap.eq(i).width() + parseInt($rdoWrap.eq(i).css('margin-right'))
                        }
                    }
                    for(i=0; i <  $rdoWrap.length; i++){
                       if( moveX < leftArr[i] && left == null ){
                            if(i == 0){
                                left = 0;
                            }else{
                                left = leftArr[i+(dirNum*-1)];
                            }
                       }
                    }
                    $rdoFlex.clearQueue().stop().animate({scrollLeft:left},200,function(){
                        setBtnCate();
                    });
                }
                setBtnCate();
            });
            $stcikyTab.find('a').on('click',function(e){
                if($stcikyTab.vcStickyTab) { $stcikyTab.vcStickyTab('instance').offChange = true; }
                select( $(this).parent().index());
                $('html, body').stop().animate({scrollTop:'0'},200,function(){
                    if(window.innerWidth < 768){
                        $('header').removeClass('hide')
                        $('.mobile-nav-wrap').removeClass('hide')
                    }
                    $filterTabWrapParent.css('height', $filterTabWrap.outerHeight());
                });
                void 0
                var rankingType = $(this).parent().attr("id");

                if(rankingType == 'single-person'){
                    $filterTabWrap.addClass('vhidden')
                }else{
                    $filterTabWrap.removeClass('vhidden')
                }
             
                self.variable.currentCategory = $("input[name="+rankingType+"Category]:checked").data("categoryid") || '';
                if (!vcui.isEmpty(rankingType) && $("#"+rankingType+"RankingProduct").find(".ranking__item").length == 0) {
                    if ("todays" == rankingType || "present" == rankingType || "subscribe" == rankingType) {
                        if (!vcui.isEmpty(self.variable.currentCategory)) {
                            self.retrievePriceRangeList(rankingType, self.variable.currentCategory);
                            self.retrieveFilterRangeList(rankingType, self.variable.currentCategory);
                        }
                    }
                    setTimeout(function(){
                        self.retrieveBestRankingList(rankingType);
                    },200)
                } else {
                    if (!self.variable.isHistoryBack) {
                        self.setHistoryState($(this).parent().attr("id"));
                    }
                    sendDataLayer();
                }
                /*if (!self.variable.isHistoryBack) {
                    if (!vcui.isEmpty($(this).parent().attr("id"))) {
                        self.setHistoryState($(this).parent().attr("id"));
                    }
                }*/
                setBtnCate();
            })
            //MO 필터탭 모달 높이값 설정
            function setFilterH(){
                $('select').each(function(){
                    var $parent =  $(this).parent();
                    $parent.find('.ui-select-scrollarea ul').css('height','auto');
                    if(window.innerWidth < 768){
                        $parent.find('.ui-select-scrollarea ul').css('height', $parent.find('.ui-selectbox-list').height()-50 );
                    }else{
                        $parent.find('.ui-select-scrollarea ul').css('height','auto');
                    }
                });
               $('.cate-wrap').each(function(){
                    $(this).find('.cate-list').css('height','auto');
                    if(window.innerWidth < 768){
                        var h = $(this).height();
                        $(this).find('.cate-list').css('height',h-163);
                    }else{
                        $(this).find('.cate-list').css('height','auto');
                    }
                });
            }
            //PC 카테고리탭 좌우 버튼 노출 여부
            function setBtnCate(){
                if(window.innerWidth >= 768){
                    for(var i=0; i<$('.ui_stickyTab .tabs li').length; i++){
                        if($('.ui_stickyTab .tabs li').eq(i).hasClass('on')){
                            currentIdx = i
                        }
                    }
                    var $list = $('.filter-tab-wrap').find('.filter-tab-list').eq(currentIdx);
                    $list.find('.rdo-flex-wrap').each(function(){
                        var total = $(this).find('.rdo-flex .rdo-wrap').length;
                        var $lastTab = $(this).find('.rdo-flex .rdo-wrap').eq(total-1);
                        var $tabWrap = $(this).find('.rdo-flex');
                        var boNum = 2; //보정값
                        //우측 이동 버튼 노출여부
                        if($lastTab.offset().left + $lastTab.width() > $tabWrap.offset().left + $tabWrap.width() + boNum){
                            $(this).find('.btn-arrow.next').show();
                        }else{
                            $(this).find('.btn-arrow.next').hide();
                        }
                        //좌측 이동 버튼 노출여부
                        if($tabWrap.scrollLeft() > 0){
                            $(this).find('.btn-arrow.prev').show();
                        }else{
                            $(this).find('.btn-arrow.prev').hide();
                        }
                    });
                }else{
                    $('.btn-arrow').hide();
                }
            }
            //푸터 높이값이 안맞을때
            function posFooter(){
                $('footer').css('margin-top',0)
                if($(window).height() > $('footer').offset().top + $('footer').height()){
                    var h = $(window).height() - ($('footer').offset().top + $('footer').height())
                    $('footer').css('margin-top',h+100)
                }
            }
        
            //탭컨텐츠 교체 관련
            $stcikyTab.on('stickyTabchange',function(e,_obj){
                select(_obj.selectedIndex);
            });
            function select(_idx, _isSlideMove){
                var tabIns = $stcikyTab.vcStickyTab('instance');
                tabIns.select(_idx, true);

                for(var i=0; i<$filterTabWrap.find('.filter-tab-list').length; i++){
                    if(i == _idx){
                        $filterTabWrap.find('.filter-tab-list').eq(i).show();
                    }else{
                        $filterTabWrap.find('.filter-tab-list').eq(i).hide();
                    }
                }
                $filterTabWrapParent.css('height',$filterTabWrap.outerHeight());
                currentIdx = _idx;

                setBtnCate();
                //MO 서브타이틀 PC에서 로드 후 반영
                var $titleWrap = $('.ranking__title-wrap.pc-only').eq(currentIdx)
                var title = $titleWrap.find('.tit').text();
                var text = $titleWrap.find('.txt').text();
                $('.ranking__title-wrap.mo-only').find('.tit').text(title)
                $('.ranking__title-wrap.mo-only').find('.txt').text(text);

                $('.filter-tab-wrap,.sub-ranking__content').addClass('active');
                posFooter();
                $(window).trigger('resize')
            }
        },
        visibleBottomBar:function(_is){
            if(_is){
                lgkorUI.showAppBottomMenu(true);
                $('html, body').removeClass('no-scroll')
                if(window.innerWidth < 768 && !isApp()){
                    $('.mobile-status-bar').show();
                }
            }else{
                lgkorUI.showAppBottomMenu(false);
                $('html, body').addClass('no-scroll')
                if(!isApp()){
                    $('.mobile-status-bar').hide();
                }
            }
        },
        setFilterCheckbox:function(){
            var self = this;
            $('.btn-cate').off('click').on('click', function(){
                if( $(this).parents('.select-wrap').hasClass('cate-open') ){
                    self.visibleBottomBar(true)

                    $(this).parents('.select-wrap').removeClass('cate-open');
                }else{
                    self.visibleBottomBar(false)

                    $(this).parents('.select-wrap').addClass('cate-open');
                }
            })
            $('.cate-button button:eq(0), .cate-m-close').off('click').on('click', function(){
                self.visibleBottomBar(true)

                $(this).parents('.select-wrap').removeClass('cate-open');

                // 선택된 카테고리 초기화
                $('.cate-list').find('input:checked').prop('checked', false);

                if (bestRanking.variable.selectedPackageCategory.length > 0) {
                    bestRanking.variable.selectedPackageCategory.forEach(function(item) {
                        $(".cate-list input[value="+item+"]").prop('checked', true);
                    });
                    $('.comp').prop('disabled', false);
                } else {
                    $('.cate-list').find('input:first').prop('checked', true);
                    $('.comp').prop('disabled', false);
                }

            });
            $('.cate-button button:eq(1)').off('click').on('click', function(){
                self.visibleBottomBar(true)

                $(this).parents('.select-wrap').removeClass('cate-open');
                bestRanking.retrieveBestRankingList("multiple-products");

                bestRanking.variable.selectedPackageCategory = [];
                $('.cate-list').find('input:checked').each(function() {
                    if ($(this).attr("id") != "chk-all") {
                        bestRanking.variable.selectedPackageCategory.push( $(this).val() );
                    }
                });
            });

            $('.cate-list').find('input').off('click').on('click', function(){
                if ($(this).attr("id") == "chk-all") {

                    $('.cate-list').find('input:not(:first)').prop('checked', false);
                    if ($("#chk-all").is(":checked")) {
                        $('.comp').prop('disabled', false);
                    } else {
                        $('.comp').prop('disabled', true);
                    }

                } else {
                    $('.cate-list').find('input:first').prop('checked', false);
                    if( $('.cate-list').find('input:checked').length  < 2 ){
                        $('.comp').prop('disabled', true);
                    } else{
                        $('.comp').prop('disabled', false);
                    }
                }
            });
            //필터외 배경 클릭시 필터 닫기
            $(document).on('touchstart.checkbox mousedown.checkbox', function (e) {
                setTimeout(function(){
                    if($('.select-wrap.cate-open').length > 0 && $(e.target).parents('.select-wrap.cate-open').length == 0){
                        $('.cate-m-close').trigger('click')
                    }
                },200)
            });
        },
        bindEvents: function(){
            var self = this;
            self.setFilterCheckbox();
            self.changeSuperCategory();
            self.changeCategory();
            self.changePrice();
            self.changeFilter();
            self.changeCheckList();

            //APP > 필터 셀렉트 열고 닫기시 앱 하단바 비노출, 노출
            $('.ui_selectbox').on('selectboxopen', function(e,data){
                self.visibleBottomBar(false)
            })
            .on('selectboxclose', function(e,data){
                self.visibleBottomBar(true)
            });
        },
        setCacheCategory : function(_$categoryList,_html,_rankingType){
            void 0;
            var self = this;
            _$categoryList.html(_html);

            //2뎁스 탭
            var superRadioIdx = _$categoryList.find('.rdo-flex').eq(0).attr('data-checked-index');
            var radioIdx = _$categoryList.find('.rdo-flex').eq(1).attr('data-checked-index');

            _$categoryList.find("#"+_rankingType+"SuperCategory .rdo-wrap").eq(superRadioIdx).find('input').prop('checked',true);
            _$categoryList.find("#"+_rankingType+"Category .rdo-wrap").eq(radioIdx).find('input').prop('checked',true);

        },
        setCacheFilter : function(_$filerList,_html){
            void 0;
            var self = this;
            _$filerList.html(_html);
            if(_$filerList.attr('id') == 'todays_filter_content'){
                setTimeout(function(){
                    $(window).trigger('setTabSync', true);
                },100);
            }
            if(_$filerList.attr('id') == 'subscribe_filter_content'){
                setTimeout(function(){
                    $(window).trigger('setTabSync', true);
                },100);
            }
            if(_$filerList.attr('id') == 'employee_filter_content'){
                setTimeout(function(){
                    $(window).trigger('setTabSync', true);
                },100);
            }
//            //2뎁스 탭
//            var radioIdx = _$filerList.find('.rdo-flex').attr('data-checked-index');
//            _$filerList.find('.rdo-wrap').eq(radioIdx).find('input').prop('checked',true);
            //셀렉트 필터
            _$filerList.find('.ui_selectbox').each(function(i){
                var idx = $(this).attr('data-selected-index');
                $(this).vcSelectbox('selectedIndex',idx, false); // selectbox 'change' trigger 발생하지 않토록 false 인자 추가 // BTOCSITE-63854 [베스트랭킹] 오늘의랭킹으로 뒤로가기 시 Layout Shift 발생
            });
            //체크 필터
            if(_$filerList.find('.cate-wrap').length>0){
                self.setFilterCheckbox();
                $('.cate-list').find('input').prop('checked', false);
                _$filerList.find('.cate-wrap input[type=checkbox]').each(function(i){
                    if($(this).attr('data-checked') == 'true'){
                        $(this).prop('checked',true);
                    }
                });
            }
            //오늘의 랭킹 체크 필터2
            if(_$filerList.find('.chk-list.todays').length>0){
                $('.chk-list.todays').find('input').prop('checked', false);
                _$filerList.find('.chk-list.todays input[type=checkbox]').each(function(i){
                    if($(this).attr('data-checked') == 'true'){
                        $(this).prop('checked',true);
                    }
                });
            }
            //임직원 랭킹 체크 필터2
            if(_$filerList.find('.chk-list.employee').length>0){
                $('.chk-list.employee').find('input').prop('checked', false);
                _$filerList.find('.chk-list.employee input[type=checkbox]').each(function(i){
                    if($(this).attr('data-checked') == 'true'){
                        $(this).prop('checked',true);
                    }
                });
            }
        },
        saveCacheCategory : function(_$categoryList){
            void 0;
            var clonHtml = _$categoryList.clone();
            //2뎁스 탭
//            var idx = clonHtml.find('input:checked').parent().index();
//            clonHtml.find('.rdo-flex').attr('data-checked-index',idx);
            var cateArr = [];
            clonHtml.find('input:checked').each(function(i){
                cateArr.push($(this).parent().index());
            });

            clonHtml.find('.rdo-flex').eq(0).attr('data-checked-index',cateArr[0]);
            clonHtml.find('.rdo-flex').eq(1).attr('data-checked-index',cateArr[1]);

            return clonHtml.html();
        },
        saveCacheFilter : function(_$filerList){
            void 0;
            var clonHtml = _$filerList.clone();
            //셀렉트 필터
            var selectArr = [];
            clonHtml.find('.ui-selectbox-list').each(function(i){
                selectArr.push($(this).find('li.on').index());
            });
            clonHtml.find('.ui-selectbox-wrap').remove();
            clonHtml.find('.ui_selectbox').removeAttr('ui-modules').removeAttr('data-width-class').removeAttr('style').removeAttr('data-selected-index');
            clonHtml.find('.ui_selectbox').each(function(i){
                $(this).attr('data-selected-index',selectArr[i]);
            });
            //체크 필터
            if(clonHtml.find('.cate-wrap').length>0){
                clonHtml.find('.cate-wrap input[type=checkbox]').removeAttr('data-checked');
                clonHtml.find('.cate-wrap input[type=checkbox]').each(function(i){
                    if($(this).prop('checked') == true){
                        $(this).attr('data-checked',true)
                    }
                });
            }

            //오늘의 랭킹 체크필터 2
            if(clonHtml.find('.chk-list.todays').length>0){
                clonHtml.find('.chk-list.todays input[type=checkbox]').removeAttr('data-checked');
                clonHtml.find('.chk-list.todays input[type=checkbox]').each(function(i){
                    if($(this).prop('checked') == true){
                        $(this).attr('data-checked',true)
                    }
                });
            }

            //임직원 랭킹 체크필터 2
            if(clonHtml.find('.chk-list.employee').length>0){
                clonHtml.find('.chk-list.employee input[type=checkbox]').removeAttr('data-checked');
                clonHtml.find('.chk-list.employee input[type=checkbox]').each(function(i){
                    if($(this).prop('checked') == true){
                        $(this).attr('data-checked',true)
                    }
                });
            }
            return clonHtml.html();
        },
        //필터 변경시 리스트 상단으로 이동(스티키 풀리기 직전으로)
        stickyTop : function(){
            var self = this;
            $(window).scrollTop(self.$brandMain.find('.ui_sticky_wrap').parent().offset().top+2);
            if(window.innerWidth < 768){
                setTimeout(function(){
                    // $('.sub-renew-nav-wrap').addClass('hide').show();
                    // $('.header').addClass('hide').show();
                    self.$brandMain.find('.ui_sticky_wrap').removeClass('down').addClass('up');
                    self.$brandMain.find('.filter-tab-wrap').removeClass('down').addClass('up');
                });
            }
        },
        /**
         * 가격 필터 세팅
         */
        setPriceFilter : function() {
            // 혼수/이사 패키지 가격 필터
            bestRanking.retrievePriceRangeList('multiple-products', '');
            // 시즌선물 가격 필터
            bestRanking.retrievePriceRangeList('present', '');
        },

        /**
        * 슈퍼 카테고리 변경
        */
        changeSuperCategory : function(){
            $("input[name='todaysSuperCategory']").off("click").on('click', function() {
                var categorySeq = $(this).attr('id');
                var rankingType = $(this).attr('name').replace('SuperCategory','');
                var categoryId  = $(this).data("categoryid");
                var self = this;
                var param = {}
                param.rankingType = rankingType;
                param.categoryId = categoryId;
                // BTOCSITE-77409 START
                isClickSuperCategoryIdTodays = true; 
                superCategoryNameTodays = $(this).data("categoryname");
                // BTOCSITE-77409 END

                // BTOCSITE-77409 START
                if (categoryId !== undefined && categoryId !== "") {
                    $('.todays-ranking').parents('.tab-contents').find('h3 span.blind').text('오늘의 랭킹 탭의 '+ superCategoryNameTodays +' 목록')
                } else {
                    $('.todays-ranking').parents('.tab-contents').find('h3 span.blind').text('오늘의 랭킹 탭의 전체 목록');
                }
                // BTOCSITE-77409 END

                var sendUrl = "/mkt/api/bestRanking/retrieveCategoryList.lgajax";
                lgkorUI.requestAjaxData(sendUrl, param, function(result) {
                    var viewFlag = "N";
                    //전체 Tab
                    if(!vcui.isEmpty(categoryId)){
                        viewFlag = "Y";
                    }

                    if (result.data[0].categoryList != null && result.data[0].categoryList.length > 0) {
                        void 0;
                        //대카만 있는 경우.
                        if(categoryId==result.data[0].categoryList[0].categoryId){
                            viewFlag="N";
                        }

                        var categoryList = result.data[0].categoryList;
                        $("#todaysCategory").html(vcui.template(subCategoryTemplate, {rankingType:rankingType,viewFlag:viewFlag ,categorySeq:categorySeq,categoryList:categoryList}));

                        //이벤트 재바인딩
                        bestRanking.changeCategory();

                        if(!vcui.isEmpty(categoryId)){
                            $('#todaysCategory').find('input').eq(0).trigger('click');
                        }else{//전체 Tab
                            $('.chk-list').find('input').prop('checked', false);
                            $("#todaysPrice").parent().addClass('opacity0').show();
                            $("#todaysFilter").parent().addClass('opacity0').show();

                            $('#todaysPrice').children('option:not(:first)').remove();
                            $("#todaysPrice").vcSelectbox('update');

                            $('#todaysFilter').children('option:not(:first)').remove();
                            $("#todaysFilter").vcSelectbox('update');

                            bestRanking.filterDisable("todays");

                            var specName = "주요 스펙(전체)";
                            $("#todaysFilter option:eq(0)").text(specName);
                            $("#todaysFilter").vcSelectbox('update');
                            bestRanking.retrieveBestRankingList("todays");

                            $("#todaysPrice").parent().removeClass('opacity0');
                            $("#todaysFilter").parent().removeClass('opacity0');
                        }
                    }
                }, "POST", "json");
            }).prop('disabled',false);

            $("input[name='subscribeSuperCategory']").off("click").on('click', function() {
                var categorySeq = $(this).attr('id');
                var rankingType = $(this).attr('name').replace('SuperCategory','');
                var categoryId  = $(this).data("categoryid");
                var self = this;
                var param = {}
                param.rankingType = rankingType;
                param.categoryId = categoryId;
                // BTOCSITE-77409 START
                superCategoryNameSubscribe = $(this).data("categoryname");
                isClickSuperCategoryIdSubscribe = true; 
                // BTOCSITE-77409 END

                // BTOCSITE-77409 START
                if (categoryId !== undefined && categoryId !== "") {
                    $('.subscribe-ranking').parents('.tab-contents').find('h3 span.blind').text('가전 구독 랭킹 탭의 '+ superCategoryNameSubscribe +' 목록');
                } else {
                    $('.subscribe-ranking').parents('.tab-contents').find('h3 span.blind').text('가전 구독 랭킹 탭의 전체 목록');
                }
                // BTOCSITE-77409 END

                var sendUrl = "/mkt/api/bestRanking/retrieveCategoryList.lgajax";
                lgkorUI.requestAjaxData(sendUrl, param, function(result) {
                    var viewFlag = "N";
                    //전체 Tab
                    if(!vcui.isEmpty(categoryId)){
                        viewFlag = "Y";
                    }

                    if (result.data[0].categoryList != null && result.data[0].categoryList.length > 0) {
                        void 0;
                        //대카만 있는 경우.
                        if(categoryId==result.data[0].categoryList[0].categoryId){
                            viewFlag="N";
                        }

                        var categoryList = result.data[0].categoryList;
                        $("#subscribeCategory").html(vcui.template(subCategoryTemplate, {rankingType:rankingType,viewFlag:viewFlag ,categorySeq:categorySeq,categoryList:categoryList}));

                        //이벤트 재바인딩
                        bestRanking.changeCategory();

                        if(!vcui.isEmpty(categoryId)){
                            $('#subscribeCategory').find('input').eq(0).trigger('click');
                        }else{//전체 Tab
                            $("#subscribePrice").parent().addClass('opacity0').show();
                            $("#subscribeFilter").parent().addClass('opacity0').show();

                            $('#subscribePrice').children('option:not(:first)').remove();
                            $("#subscribePrice").vcSelectbox('update');

                            $('#subscribeFilter').children('option:not(:first)').remove();
                            $("#subscribeFilter").vcSelectbox('update');

                            bestRanking.filterDisable("subscribe");

                            var specName = "주요 스펙(전체)";
                            $("#subscribeFilter option:eq(0)").text(specName);
                            $("#subscribeFilter").vcSelectbox('update');
                            bestRanking.retrieveBestRankingList("subscribe");

                            $("#subscribePrice").parent().removeClass('opacity0');
                            $("#subscribeFilter").parent().removeClass('opacity0');
                        }
                    }
                }, "POST", "json");
            }).prop('disabled',false);

            $("input[name='employeeSuperCategory']").off("click").on('click', function() {
                var categorySeq = $(this).attr('id');
                var rankingType = $(this).attr('name').replace('SuperCategory','');
                var categoryId  = $(this).data("categoryid");
                var self = this;
                var param = {}
                param.rankingType = rankingType;
                param.categoryId = categoryId;
                // BTOCSITE-77409 START
                superCategoryNameEmployee = $(this).data("categoryname");
                isClickSuperCategoryIdEmployee = true;
                // BTOCSITE-77409 END

                // BTOCSITE-77409 START
                if (categoryId !== undefined && categoryId !== "") {
                    $('.employee-ranking').parents('.tab-contents').find('h3 span.blind').text('임직원 랭킹 탭의 '+ superCategoryNameEmployee +'리의 목록');
                } else {
                    $('.employee-ranking').parents('.tab-contents').find('h3 span.blind').text('임직원 랭킹 탭의 전체 목록');
                }
                // BTOCSITE-77409 END

                var sendUrl = "/mkt/api/bestRanking/retrieveCategoryList.lgajax";
                lgkorUI.requestAjaxData(sendUrl, param, function(result) {
                    var viewFlag = "N";
                    //전체 Tab
                    if(!vcui.isEmpty(categoryId)){
                        viewFlag = "Y";
                    }

                    if (result.data[0].categoryList != null && result.data[0].categoryList.length > 0) {
                        void 0;
                        //대카만 있는 경우.
                        if(categoryId==result.data[0].categoryList[0].categoryId){
                            viewFlag="N";
                        }

                        var categoryList = result.data[0].categoryList;
                        $("#employeeCategory").html(vcui.template(subCategoryTemplate, {rankingType:rankingType,viewFlag:viewFlag ,categorySeq:categorySeq,categoryList:categoryList}));

                        //이벤트 재바인딩
                        bestRanking.changeCategory();

                        if(!vcui.isEmpty(categoryId)){
                            $('#employeeCategory').find('input').eq(0).trigger('click');
                        }else{//전체 Tab
                            $("#employeePrice").parent().addClass('opacity0').show();
                            $("#employeeFilter").parent().addClass('opacity0').show();

                            $('#employeePrice').children('option:not(:first)').remove();
                            $("#employeePrice").vcSelectbox('update');

                            $('#employeeFilter').children('option:not(:first)').remove();
                            $("#employeeFilter").vcSelectbox('update');

                            bestRanking.filterDisable("employee");

                            var specName = "주요 스펙(전체)";
                            $("#employeeFilter option:eq(0)").text(specName);
                            $("#employeeFilter").vcSelectbox('update');
                            bestRanking.retrieveBestRankingList("employee");

                            $("#employeePrice").parent().removeClass('opacity0');
                            $("#employeeFilter").parent().removeClass('opacity0');
                        }
                    }
                }, "POST", "json");
            }).prop('disabled',false);
        },

        /**
         * 카테고리 변경
         */
        changeCategory : function() {
            $("input[name='todaysCategory']").off("click").on('click', function() {
                var categoryId = $(this).data("categoryid");
                var categoryName  = $(this).data("categoryname"); // BTOCSITE-77409
                $("#todaysPrice").parent().addClass('opacity0').show();
                $("#todaysFilter").parent().addClass('opacity0').show();

                $('#todaysPrice').children('option:not(:first)').remove();
                $("#todaysPrice").vcSelectbox('update');

                $('#todaysFilter').children('option:not(:first)').remove();
                $("#todaysFilter").vcSelectbox('update');

                $('.chk-list').find('input').prop('checked', false);

                // BTOCSITE-77409 START
                if (!isClickSuperCategoryIdTodays) {
                    $('.todays-ranking').parents('.tab-contents').find('h3 span.blind').text('오늘의 랭킹 탭의 '+ superCategoryNameTodays +' 카테고리의 '+ categoryName +' 목록');
                } else {
                    isClickSuperCategoryIdTodays = false;
                }
                // BTOCSITE-77409 END

                if (!vcui.isEmpty(categoryId)) {
                $.when(bestRanking.retrievePriceRangeList('todays', categoryId),bestRanking.retrieveFilterRangeList('todays', categoryId))
                  .done(function(){
                    bestRanking.retrieveBestRankingList("todays");
                  });
                }
                bestRanking.variable.currentCategoryId = categoryId || '';
            }).prop('disabled',false);

            $("input[name='subscribeCategory']").off("click").on('click', function() {
                var categoryId = $(this).data("categoryid");
                var categoryName  = $(this).data("categoryname"); // BTOCSITE-77409
                $("#subscribePrice").parent().addClass('opacity0').show();
                $("#subscribeFilter").parent().addClass('opacity0').show();

                $('#subscribePrice').children('option:not(:first)').remove();
                $("#subscribePrice").vcSelectbox('update');

                $('#subscribeFilter').children('option:not(:first)').remove();
                $("#subscribeFilter").vcSelectbox('update');

                // BTOCSITE-77409 START
                if (!isClickSuperCategoryIdSubscribe) {
                    $('.subscribe-ranking').parents('.tab-contents').find('h3 span.blind').text('가전 구독 랭킹 탭의 '+ superCategoryNameSubscribe +' 카테고리의 '+ categoryName +' 목록');
                } else {
                    isClickSuperCategoryIdSubscribe = false;
                }
                // BTOCSITE-77409 END

                if (!vcui.isEmpty(categoryId)) {
                    $.when(bestRanking.retrievePriceRangeList('subscribe', categoryId),bestRanking.retrieveFilterRangeList('subscribe', categoryId))
                      .done(function(){
                        bestRanking.retrieveBestRankingList("subscribe");
                      });
                }
                bestRanking.variable.currentCategoryId = categoryId || '';
            }).prop('disabled',false);

            $("input[name='employeeCategory']").off("click").on('click', function() {
                var categoryId = $(this).data("categoryid");
                var categoryName  = $(this).data("categoryname"); // BTOCSITE-77409
                $("#employeePrice").parent().addClass('opacity0').show();
                $("#employeeFilter").parent().addClass('opacity0').show();

                $('#employeePrice').children('option:not(:first)').remove();
                $("#employeePrice").vcSelectbox('update');

                $('#employeeFilter').children('option:not(:first)').remove();
                $("#employeeFilter").vcSelectbox('update');

                // BTOCSITE-77409 START
                if (!isClickSuperCategoryIdEmployee) {
                    $('.employee-ranking').parents('.tab-contents').find('h3 span.blind').text('임직원 랭킹 탭의 '+ superCategoryNameEmployee +' 카테고리의 '+ categoryName +' 목록');
                } else {
                    isClickSuperCategoryIdEmployee = false;
                }
                // BTOCSITE-77409 END

                if (!vcui.isEmpty(categoryId)) {
                    /*$.when(bestRanking.retrievePriceRangeList('employee', categoryId),bestRanking.retrieveFilterRangeList('employee', categoryId))
                      .done(function(){
                        bestRanking.retrieveBestRankingList("employee");
                      });*/ //필터, 가격 세팅 이후 주석 제거
                      setTimeout(function(){
                      bestRanking.retrieveBestRankingList("employee");}, 200);
                      //bestRanking.retrieveBestRankingList("employee");
                }
                bestRanking.variable.currentCategoryId = categoryId || '';
            }).prop('disabled',false);

            $("input[name='presentCategory']").off("click").on('click', function() {
                var categoryId = $(this).data("categoryid") || '';

                $('#presentPrice').children('option:not(:first)').remove();
                $("#presentPrice").vcSelectbox('update');

                bestRanking.retrievePriceRangeList('present', categoryId);
                bestRanking.retrieveBestRankingList("present");
                bestRanking.variable.currentCategoryId = categoryId || '';
            }).prop('disabled',false);

            $("#presentCategory_mo").off("change").on('change', function() {
                $(this).vcSelectbox('update');
                var categoryId = $(this).val() || '';
                if (bestRanking.variable.currentCategoryId == categoryId) {
                    return;
                }

                $('#presentPrice').children('option:not(:first)').remove();
                $("#presentPrice").vcSelectbox('update');

                bestRanking.retrievePriceRangeList('present', categoryId);
                bestRanking.retrieveBestRankingList("present");
                bestRanking.variable.currentCategoryId = categoryId || '';
            });
        },
        changePrice : function() {
            $("#todaysPrice").off('change').on('change', function() {
                bestRanking.retrieveBestRankingList("todays");
                $(this).vcSelectbox('update');
            });

            $("#multiple-productsPrice").off('change').on('change', function() {
                bestRanking.retrieveBestRankingList("multiple-products");
                $(this).vcSelectbox('update');
            });

            $("#presentPrice").off('change').on('change', function() {
                bestRanking.retrieveBestRankingList("present");
                $(this).vcSelectbox('update');
            });

            $("#subscribePrice").off('change').on('change', function() {
                bestRanking.retrieveBestRankingList("subscribe");
                $(this).vcSelectbox('update');
            });

            $("#employeePrice").off('change').on('change', function() {
                bestRanking.retrieveBestRankingList("employee");
                $(this).vcSelectbox('update');
            });

        },
        changeFilter : function() {
            $("#todaysFilter").off('change').on('change', function() {
                bestRanking.retrieveBestRankingList("todays");
                //선택된 셀렉트 타이틀 갱신 안되는 오류 수정
                $(this).vcSelectbox('update');
            });

            $("#subscribeFilter").off('change').on('change', function() {
                bestRanking.retrieveBestRankingList("subscribe");
                //선택된 셀렉트 타이틀 갱신 안되는 오류 수정
                $(this).vcSelectbox('update');
            });
        },
        changeCheckList : function(){
            $('.chk-list').off('change').on('change',function(){
                if($('.chk-list.todays').is(':visible')){
                    bestRanking.retrieveBestRankingList("todays");
                }else{
                    bestRanking.retrieveBestRankingList("employee");
                }
            });

        },
        resizeProductWrap : function() {
            $(window).trigger('resize').trigger('resizeend');
        },
        filterDisable : function(rankingType) {
            $("#"+rankingType+"Price").prop("disabled", true);
            $("#"+rankingType+"Filter").prop("disabled", true);
            $("#"+rankingType+"Price").vcSelectbox('update');
            $("#"+rankingType+"Filter").vcSelectbox('update');
        },

        /**
         * 상품 리스트 조회
         * @param type
         */
        isMoveSticky: false,
        retrieveBestRankingList : function(rankingType) {
            var self = this;
            var sendUrl = "/mkt/api/bestRanking/retrieveCategoryProductList.lgajax";
            var categoryId = "";
            var categoryIds = "";
            var categoryUrlPath, categoryName;
            var categoryNames = [];
            var minPrice, maxPrice, filterId, otherMinPrice, otherMaxPrice, otherPriceRangeText, keyword;
            var empYn = digitalData.userInfo.empYn;
            if (rankingType == "multiple-products") {
                $('.cate-list').find('input:checked').each(function() {
                    if ($(this).attr("id") != 'chk-all') {
                        categoryId += $(this).val() + ",";
                        categoryNames.push($(this).next("label").text());
                    } else {
                        categoryNames.push("카테고리 (전체)");
                    }
                });
                categoryId = categoryId.trim().slice(0, -1);
                minPrice = $("#"+rankingType+"Price option:selected").data('minprice');
                maxPrice = $("#"+rankingType+"Price option:selected").data('maxprice');

                otherMinPrice = $("#"+rankingType+"Price option:selected").prev().data('minprice');
                otherMaxPrice = $("#"+rankingType+"Price option:selected").prev().data('maxprice');

                otherPriceRangeText = $("#"+rankingType+"Price option:selected").next().text();
            } else {
                // 모바일, 추천선물 탭일경우
                if(vcui.detect.isMobile && 'present' == rankingType) {
                    categoryId = $("#presentCategory_mo option:selected").val();
                } else {
                    categoryId = $("input[name="+rankingType+"Category]:checked").data("categoryid") || '';
                }
                minPrice = $("#"+rankingType+"Price option:selected").data('minprice');
                maxPrice = $("#"+rankingType+"Price option:selected").data('maxprice');
                filterId = $("#"+rankingType+"Filter option:selected").val();
                otherMinPrice = $("#"+rankingType+"Price option:selected").next().data('minprice');
                otherMaxPrice = $("#"+rankingType+"Price option:selected").next().data('maxprice');
                otherPriceRangeText = $("#"+rankingType+"Price option:selected").next().text();

                categoryUrlPath = $("input[name="+rankingType+"Category]:checked").data("category-url-path");
                categoryName = $("input[name="+rankingType+"Category]:checked").next().text();
                keyword =  $("#"+rankingType).data("keyword");

                if (vcui.isEmpty(categoryId)) {
                    $("input[name="+rankingType+"Category]").each(function() { categoryIds += $(this).data("categoryid") + ",";   });
                    categoryIds = categoryIds.trim().slice(0, -1);
                }

                var todayMltpModelYn ="N";
                var todayTimeModelYn ="N";
                var todayTmrrModelYn ="N";
                // 체크 박스 체크
                if ($('.chk-list.todays').find('.chk-wrap input[name=chk_mltpModelYn]').is(':checked')) {
                    todayMltpModelYn = 'Y';
                }
                if ($('.chk-list.todays').find('.chk-wrap input[name=chk_timeDeal]').is(':checked')) {
                    todayTimeModelYn = 'Y';
                }
                if ($('.chk-list.todays').find('.chk-wrap input[name=chk_tomorrowDeliveryFlag]').is(':checked')) {
                    todayTmrrModelYn = 'Y';
                }

                var employeeMltpModelYn ="N";
                var employeeTimeModelYn ="N";
                var employeeTmrrModelYn ="N";
                // 체크 박스 체크
                if ($('.chk-list.employee').find('.chk-wrap input[name=chk_mltpModelYn_2]').is(':checked')) {
                    employeeMltpModelYn = 'Y';
                }
                if ($('.chk-list.employee').find('.chk-wrap input[name=chk_timeDeal_2]').is(':checked')) {
                    employeeTimeModelYn = 'Y';
                }
                if ($('.chk-list.employee').find('.chk-wrap input[name=chk_tomorrowDeliveryFlag_2]').is(':checked')) {
                    employeeTmrrModelYn = 'Y';
                }

            }
            var requestData = {
                rankingType:rankingType,
                categoryId: categoryId,
                minPrice: minPrice,
                maxPrice:maxPrice,
                filterId:filterId,
                otherMinPrice:otherMinPrice,
                otherMaxPrice:otherMaxPrice,
                categoryIds:categoryIds,
                keyword:keyword
            }

            if(rankingType == "todays"){
                 requestData.mltpModelYn = todayMltpModelYn;
                 requestData.timeModelYn = todayTimeModelYn;
                 requestData.tmrrModelYn = todayTmrrModelYn;
            }

            if(rankingType == "employee"){
                 requestData.mltpModelYn = employeeMltpModelYn;
                 requestData.timeModelYn = employeeTimeModelYn;
                 requestData.tmrrModelYn = employeeTmrrModelYn;
            }

            lgkorUI.showLoading();
            lgkorUI.requestAjaxData(sendUrl, requestData, function(result) {
                void 0;

                if (rankingType == 'multiple-products') {

                    if (!vcui.isEmpty(categoryNames)) {
                        var combineCategoryName = "";
                        categoryNames.forEach(function(item, index) {
                            combineCategoryName += item + " + "
                        });
                        combineCategoryName = combineCategoryName.trim().slice(0, -1).trim();

                        $("#multiple-productsFilterName").text(combineCategoryName);
                        if ("카테고리 (전체)" != combineCategoryName) {
                            if (combineCategoryName.split("+").length - 1 > 1) {
                                setTextOverflowEtc($('.btn-cate'));
                            }
                        }
                    }

                    if (result.data[0].multipleBestRankingList != null && result.data[0].multipleBestRankingList.length > 0) {
                        $("#"+rankingType+"RankingNoResult").hide();
                        $("#"+rankingType+"RankingOpinion").hide();
                        $("#"+rankingType+"BottomRecommend").hide();
                        if (result.data[0].priceRecommendYn == "Y" || result.data[0].categoryRecommendYn == "Y") {
                            var multipleBestRankingList = [];
                            multipleBestRankingList.push(result.data[0].multipleBestRankingList[0]);
                            $("#multiple-productsRankingProduct").html(vcui.template(packageProductTemplate, {categoryName: combineCategoryName == "카테고리 (전체)" ? "" : combineCategoryName, multipleBestRankingList: multipleBestRankingList, downTimeYn:result.data[0].downTimeYn}));
                        } else {
                            $("#multiple-productsRankingProduct").html(vcui.template(packageProductTemplate, {categoryName: combineCategoryName == "카테고리 (전체)" ? "" : combineCategoryName, multipleBestRankingList: result.data[0].multipleBestRankingList, downTimeYn:result.data[0].downTimeYn}));
                        }

                    } else {
                        $("#"+rankingType+"RankingProduct").html('');
                        $("#"+rankingType+"RankingNoResult").html(vcui.template(noResultTemplate, {rankingType:rankingType}));
                        $("#"+rankingType+"BottomRecommend").hide();
                        $("#"+rankingType+"RankingNoResult").show();

                    }
                    // 가격 추천이 있을때
                    if (result.data[0].priceRecommendYn == "Y") {

                        otherPriceRangeText = $("#multiple-productsPrice option:selected").prev().text();
                        $("#"+rankingType+"RankingNoResult").html(vcui.template(noResultTemplate, {rankingType:rankingType}));
                        $("#"+rankingType+"RankingNoResult").show();
                        $(".tit-cate").html('');
                        $(".tit-cate").hide();

                        $("#"+rankingType+"RankingOpinion").html(vcui.template(packageOpinionTempalte, {categoryName:'', priceRangeText:otherPriceRangeText}));
                        $("#"+rankingType+"RankingOpinion").show();

                        if (result.data[0].multipleBestRankingList.length > 1) {
                            $("#"+rankingType+"BottomRecommend").html(vcui.template(packageBottomRecommendTemplate, {categoryName:'', priceRangeText:otherPriceRangeText, rankingType:rankingType}))
                            $("#"+rankingType+"BottomRecommend").show();
                        } else {
                            $("#"+rankingType+"BottomRecommend").hide();
                        }
                    }
                    // 카테고리 추천이 있을때
                    if (result.data[0].categoryRecommendYn == "Y") {
                        var recommendCategoryName = "";
                        var categoryRecommendIdList = result.data[0].categoryRecommendIdList;
                        if (!vcui.isEmpty(categoryRecommendIdList)) {
                            result.data[0].categoryRecommendIdList.forEach(function(item) {
                                recommendCategoryName += $(".cate-list input[value="+item+"]").next().text() + ' + ';
                            });
                        }
                        recommendCategoryName = recommendCategoryName.trim().slice(0, -1);
                        $("#"+rankingType+"RankingNoResult").html(vcui.template(noResultTemplate, {rankingType:rankingType}));
                        $("#"+rankingType+"RankingNoResult").show();
                        $(".tit-cate").html('');
                        $(".tit-cate").hide();

                        $("#"+rankingType+"RankingOpinion").html(vcui.template(packageOpinionTempalte, {categoryName:recommendCategoryName, priceRangeText:''}));
                        $("#"+rankingType+"RankingOpinion").show();
                        if (result.data[0].multipleBestRankingList.length > 1) {
                            $("#"+rankingType+"BottomRecommend").html(vcui.template(packageBottomRecommendTemplate, {categoryName:recommendCategoryName, priceRangeText:'', categoryRecommendIdList :categoryRecommendIdList}))
                            $("#"+rankingType+"BottomRecommend").show();
                        } else {
                            $("#"+rankingType+"BottomRecommend").hide();
                        }

                    }

                } else if(rankingType == 'subscribe'){
                    if (result.data[0].priceRecommendYn == "Y") {
                        if (result.data[0].subscribeRankingList != null && result.data[0].subscribeRankingList.length > 1) {
                            $("#"+rankingType+"RankingNoResult").html(vcui.template(noResultTemplate, {rankingType:rankingType}));
                            $("#"+rankingType+"RankingOpinion").html(vcui.template(opinionTempalte, {priceRangeText:otherPriceRangeText}));
                            $("#"+rankingType+"RankingNoResult").show();
                            $("#"+rankingType+"RankingOpinion").show();
                            var prdList, isShowMoreBtn;

                            if(vcui.detect.isMobile) {
                                prdList = result.data[0].subscribeRankingList.slice(0, 2);
                                isShowMoreBtn = result.data[0].subscribeRankingList.length > 2 ? true : false;
                            } else {
                                prdList = result.data[0].subscribeRankingList;
                                isShowMoreBtn = result.data[0].subscribeRankingList.length > 3 ? true : false;
                            }
                            $("#"+rankingType+"RankingProduct").html(vcui.template(subscribeProductTemplate, {productList: prdList ,empYn:empYn}));
                            if (isShowMoreBtn) {
                                $("#"+rankingType+"BottomRecommend").html(vcui.template(bottomRecommendTemplate, {categoryName:'',categoryUrlPath:'',priceRangeText:otherPriceRangeText, rankingType:rankingType}));
                                $("#"+rankingType+"BottomRecommend").show();
                            } else {
                                $("#"+rankingType+"BottomRecommend").hide();
                            }
                        } else {
                            $("#"+rankingType+"RankingNoResult").html(vcui.template(noResultTemplate, {rankingType:rankingType}));
                            $("#"+rankingType+"RankingNoResult").show();
                            $("#"+rankingType+"RankingProduct").html('');
                            $("#"+rankingType+"BottomRecommend").hide();
                            $("#"+rankingType+"RankingOpinion").hide();
                        }
                    } else {
                        if (result.data[0].subscribeRankingList != null && result.data[0].subscribeRankingList.length > 0) {
                            $("#"+rankingType+"RankingNoResult").hide();
                            $("#"+rankingType+"RankingOpinion").hide();
                            $("#"+rankingType+"BottomRecommend").hide();
                            $("#"+rankingType+"RankingProduct").html(vcui.template(subscribeProductTemplate, {productList: result.data[0].subscribeRankingList, empYn:empYn}));

                            if (!vcui.isEmpty(categoryId)) {
                                $("#"+rankingType+"BottomRecommend").html(vcui.template(bottomRecommendTemplate, {categoryName:categoryName,categoryUrlPath:categoryUrlPath,priceRangeText:'', rankingType:rankingType}));
                                $("#"+rankingType+"BottomRecommend").show();
                            }
                        } else {
                            $("#"+rankingType+"RankingNoResult").html(vcui.template(noResultTemplate, {rankingType:rankingType}));
                            $("#"+rankingType+"RankingNoResult").show();
                            $("#"+rankingType+"RankingProduct").html('');
                            $("#"+rankingType+"BottomRecommend").hide();
                            $("#"+rankingType+"RankingOpinion").hide();
                        }
                    }
                    // 엠블럼 노출 조회 (임직원/계열사/복지몰은 비노출)
                    var isEmblemDisplay = true;
                    if (digitalData && digitalData.userInfo && digitalData.userInfo.partnerType) {
                        if (digitalData.userInfo.partnerType == "AFF" || digitalData.userInfo.partnerType == "LGE" || digitalData.userInfo.partnerType == "AFC") {
                            isEmblemDisplay = false;
                        }
                    }
                    if (isEmblemDisplay) {
                        $("div.middle-badge-list").find('span').show();
                    }
                } else {
                    if (result.data[0].priceRecommendYn == "Y") {
                        if (result.data[0].bestRankingProductList != null && result.data[0].bestRankingProductList.length > 1) {
                            $("#"+rankingType+"RankingNoResult").html(vcui.template(noResultTemplate, {rankingType:rankingType}));
                            $("#"+rankingType+"RankingOpinion").html(vcui.template(opinionTempalte, {priceRangeText:otherPriceRangeText}));
                            $("#"+rankingType+"RankingNoResult").show();
                            $("#"+rankingType+"RankingOpinion").show();
                            var prdList, isShowMoreBtn;

                            if(vcui.detect.isMobile) {
                                prdList = result.data[0].bestRankingProductList.slice(0, 2);
                                isShowMoreBtn = result.data[0].bestRankingProductList.length > 2 ? true : false;
                            } else {
                                prdList = result.data[0].bestRankingProductList;
                                isShowMoreBtn = result.data[0].bestRankingProductList.length > 3 ? true : false;
                            }
                            $("#"+rankingType+"RankingProduct").html(vcui.template(productTemplate, {productList: prdList, empYn : empYn, downTimeYn:result.data[0].downTimeYn}));
                            if (isShowMoreBtn) {
                                $("#"+rankingType+"BottomRecommend").html(vcui.template(bottomRecommendTemplate, {categoryName:'',categoryUrlPath:'',priceRangeText:otherPriceRangeText, rankingType:rankingType}));
                                $("#"+rankingType+"BottomRecommend").show();
                            } else {
                                $("#"+rankingType+"BottomRecommend").hide();
                            }
                        } else {
                            $("#"+rankingType+"RankingNoResult").html(vcui.template(noResultTemplate, {rankingType:rankingType}));
                            $("#"+rankingType+"RankingNoResult").show();
                            $("#"+rankingType+"RankingProduct").html('');
                            $("#"+rankingType+"BottomRecommend").hide();
                            $("#"+rankingType+"RankingOpinion").hide();
                        }
                    } else {
                        if (result.data[0].bestRankingProductList != null && result.data[0].bestRankingProductList.length > 0) {
                            $("#"+rankingType+"RankingNoResult").hide();
                            $("#"+rankingType+"RankingOpinion").hide();
                            $("#"+rankingType+"BottomRecommend").hide();
                            $("#"+rankingType+"RankingProduct").html(vcui.template(productTemplate, {productList: result.data[0].bestRankingProductList, empYn : empYn, downTimeYn:result.data[0].downTimeYn}));

                            if (!vcui.isEmpty(categoryId)) {
                                $("#"+rankingType+"BottomRecommend").html(vcui.template(bottomRecommendTemplate, {categoryName:categoryName,categoryUrlPath:categoryUrlPath,priceRangeText:'', rankingType:rankingType}));
                                $("#"+rankingType+"BottomRecommend").show();
                            }
                        } else {
                            if(result.data[0].employeeRankingList != null && result.data[0].employeeRankingList.length > 0){
                                $("#"+rankingType+"RankingNoResult").hide();
                                $("#"+rankingType+"RankingOpinion").hide();
                                $("#"+rankingType+"BottomRecommend").hide();
                                $("#"+rankingType+"RankingProduct").html(vcui.template(productTemplate, {productList: result.data[0].employeeRankingList, empYn : empYn, downTimeYn:result.data[0].downTimeYn}));

                                if (!vcui.isEmpty(categoryId)) {
                                    $("#"+rankingType+"BottomRecommend").html(vcui.template(bottomRecommendTemplate, {categoryName:categoryName,categoryUrlPath:categoryUrlPath,priceRangeText:'', rankingType:rankingType}));
                                    $("#"+rankingType+"BottomRecommend").show();
                                }
                            }
                            else{
                                $("#"+rankingType+"RankingNoResult").html(vcui.template(noResultTemplate, {rankingType:rankingType}));
                                $("#"+rankingType+"RankingNoResult").show();
                                $("#"+rankingType+"RankingProduct").html('');
                                $("#"+rankingType+"BottomRecommend").hide();
                                $("#"+rankingType+"RankingOpinion").hide();
                            }
                        }
                    }
                }
                bestRanking.setStickyTabText(rankingType);
                bestRanking.resizeProductWrap();
                bestRanking.setHistoryState(rankingType);
                lgkorUI.hideLoading();
                sendDataLayer();

                //BTOCSITE-44878
                $('.item__badge').each(function(){
                    if($(this).height() == 0){
                        $(this).addClass('no_badge');
                    }
                });
            }, "POST", "json");
        },

        /**
         * 가격 필터 조회
         * @param type
         * @param categoryId
         */
        retrievePriceRangeList : function(rankingType, categoryId) {
            var deferred = $.Deferred();

            var categoryIds = "";
            var param = {}
            param.rankingType = rankingType;
            param.categoryId = categoryId;

            if (rankingType == 'multiple-products') {
                $(".cate-list").find("input").not(":first").each(function() { categoryIds += $(this).val() + ",";   });
                categoryIds = categoryIds.trim().slice(0, -1);
            }

            if (rankingType == 'present') {
                $("#presentCategory option").not(":first").each(function() { categoryIds += $(this).val() + ",";   });
                categoryIds = categoryIds.trim().slice(0, -1);
            }
            param.categoryIds = categoryIds;

            var sendUrl = "/mkt/api/bestRanking/retrievePriceRangeList.lgajax";
            lgkorUI.requestAjaxData(sendUrl, param, function(result) {
                void 0;
                var priceRangeList=[];
                if (result.data[0].priceRangeList != null && result.data[0].priceRangeList.length > 0) {
                    $("#"+rankingType+"Price").parent().removeClass('opacity0').show();
                    result.data[0].priceRangeList.forEach(function(item, index) {
                        if (item.prdCnt > 0) {
                            priceRangeList.push(item);
                        }
                    });
                    if (priceRangeList.length > 0) {
                        $("#"+rankingType+"Price").children('option:not(:first)').remove();
                        $("#"+rankingType+"Price").append(vcui.template(priceTemplate, {optionList: priceRangeList}));  // 가격대 option 리스트
                        $("#"+rankingType+"Price").prop("disabled", false);
                        $("#"+rankingType+"Price").vcSelectbox('update');
                    } else {
                        $("#"+rankingType+"Price").prop("disabled", true);
                        $("#"+rankingType+"Price").vcSelectbox('update');
                    }
                } else {
                    $("#"+rankingType+"Price").parent().removeClass('opacity0').hide();
                    $("#"+rankingType+"Price").prop("disabled", true);
                    $("#"+rankingType+"Price").vcSelectbox('update');
                }
                deferred.resolve();
            }, "POST", "json");
            return deferred.promise();
        },

        /**
         * 스펙 필터 조회
         * @param type
         * @param categoryId
         */
        retrieveFilterRangeList : function(rankingType, categoryId) {
            var deferred = $.Deferred();
            var self = this;
            var param = {}
            param.rankingType = rankingType;
            param.categoryId = categoryId;

            var sendUrl = "/mkt/api/bestRanking/retrieveSpecRangeList.lgajax";
            lgkorUI.requestAjaxData(sendUrl, param, function(result) {
                void 0;
                var specRangeList=[];
                if (result.data[0].specRangeList != null && result.data[0].specRangeList.length > 0) {
                    $("#"+rankingType+"Filter").parent().removeClass('opacity0').show();
                    result.data[0].specRangeList.forEach(function(item, index) {
                        if (item.prdCnt > 0) {
                            specRangeList.push(item);
                        }
                    });
                    if (specRangeList.length > 0) {
                        $("#"+rankingType+"Filter").children('option:not(:first)').remove();
                        $("#"+rankingType+"Filter").append(vcui.template(specTemplate, {optionList: specRangeList}));  // 가격대 option 리스트
                        $("#"+rankingType+"Filter").prop("disabled", false);
                        $("#"+rankingType+"Filter").vcSelectbox('update');
                    } else {
                        $("#"+rankingType+"Filter").prop("disabled", true);
                        $("#"+rankingType+"Filter").vcSelectbox('update');
                    }
                } else {
                    $("#"+rankingType+"Filter").parent().removeClass('opacity0').hide();
                    $("#"+rankingType+"Filter").prop("disabled", true);
                    $("#"+rankingType+"Filter").vcSelectbox('update');
                }
                deferred.resolve();
            }, "POST", "json");

            var specName = "";
            if (vcui.isEmpty(categoryId)) {
                specName =  "주요 스펙(전체)";
            } else {
                self.variable.categorySpecName.forEach(function(item) {
                    if (item.categoryId == categoryId) {
                        specName = item.specName;
                        specName = specName + " (전체)";
                    }
                });
            }
            $("#"+rankingType+"Filter option:eq(0)").text(specName);
            $("#"+rankingType+"Filter").vcSelectbox('update');

            return deferred.promise();
           },

        setStickyTabText : function(rankingType) {

            if ("todays" == rankingType || "present" == rankingType || "subscribe" == rankingType) {
                var categoryText = $("#"+rankingType+"Category option:selected").text();
                var priceText = $("#"+rankingType+"Price option:selected").text();
                var filterText = $("#"+rankingType+"Filter option:selected").text();
                $("#"+rankingType+"_category_sticky").text(categoryText);
                $("#"+rankingType+"_price_sticky").text(priceText);
                $("#"+rankingType+"_filter_sticky").text(filterText);
            } else if ("multiple-products" == rankingType) {
                var categoryText = "";
                var priceText = $("#"+rankingType+"Price option:selected").text();
                $("#"+rankingType+"_price_sticky").text(priceText);
                $('.cate-list').find('input:checked').each(function() {
                    categoryText +=  $(this).next("label").text() == "전체" ? "카테고리 (전체)" : $(this).next("label").text() + ",";
                });
                if (categoryText != '카테고리 (전체)') {
                    categoryText = categoryText.trim().slice(0, -1);
                }

                $("#"+rankingType+"_category_sticky").text(categoryText);
            }
        },

        setDefaultTab : function() {
            if (!bestRanking.variable.isHistoryBack) {
                $("#bestRankingTab > ul > li").each(function() {
                    var rankingType = $("#defaultTab").val();
                    if ($(this).attr("id") == rankingType) {
                        $("#bestRankingTab").attr('data-selected-index', $(this).index());
                    }
                });
            }
        },

        setDefaultCategory : function() {
        /*
            if (!vcui.isEmpty(sessionStorage.getItem('bestRankingTabIndex'))) {
                var index = Number(sessionStorage.getItem('bestRankingTabIndex')) + 1;
                if (!vcui.isEmpty(index) && "todays" == $("#defaultTab").val()) {
                    $("input[name=todaysCategory]").eq(index).attr("checked", true);
                    var categoryId = $("input[name=todaysCategory]").eq(index).data("categoryid");
                    if (!vcui.isEmpty(categoryId)) {
                        bestRanking.retrievePriceRangeList('todays', categoryId);
                        bestRanking.retrieveFilterRangeList('todays', categoryId);
                    }
                }
                sessionStorage.removeItem('bestRankingTabIndex');
            }
        */
            var urlParams = new URL(location.href).searchParams;
            var superCategoryId = urlParams.get('superCategoryId');
            var categoryId = urlParams.get('categoryId');
            var rankingType = $("#defaultTab").val();

            if(!vcui.isEmpty(superCategoryId) && ("todays" == rankingType || "subscribe" == rankingType)){
                var superIdx = 0;
                var categorySeq="";
                var viewFlag="Y";
                $('input[name='+rankingType+'SuperCategory]').each(function(item) {
                    if($(this).attr('data-categoryid')==superCategoryId){
                        superIdx=item;
                        categorySeq = $(this).attr('id');
                        $(this).attr("checked",true);
                    }
                })

                var param = {}

                param.rankingType = rankingType;
                param.categoryId = superCategoryId;

                var sendUrl = "/mkt/api/bestRanking/retrieveCategoryList.lgajax";
                lgkorUI.requestAjaxData(sendUrl, param, function(result) {
                    if (result.data[0].categoryList != null && result.data[0].categoryList.length > 0) {
                        void 0;
                        //대카만 있는 경우.
                        if(superCategoryId==result.data[0].categoryList[0].categoryId){
                            viewFlag="N";
                        }
                        var categoryList = result.data[0].categoryList;
                        $("#"+rankingType+"Category").html(vcui.template(subCategoryTemplate, {rankingType:rankingType,viewFlag:viewFlag ,categorySeq:categorySeq,categoryList:categoryList}));

                        //이벤트 재바인딩
                        bestRanking.changeCategory();

                        var idx = 0;
                        if(!vcui.isEmpty(categoryId)){
                            $('input[name='+rankingType+'Category]').each(function(item) {
                                if($(this).attr('data-categoryid')==categoryId){
                                    idx=item;
                                }
                            })
                        }

                        $('#'+rankingType+'Category').find('input').eq(idx).attr("checked",true);
                    }
                }, "POST", "json");
            }
        },

        setToolTip : function() {
            var self = this;
            self.variable.tooltip.forEach(function(item) {
                $("#bestRankingTab > ul > li").each(function() {
                    if ($(this).attr("id") == item.id) {
                        $("#"+item.id+"TooltipTitle").text(item.title);
                        $("#"+item.id+"TooltipDesc").text(item.desc);
                        $("#"+item.id+"TooltipTitle_tab").text(item.title);
                        $("#"+item.id+"TooltipDesc_tab").text(item.desc);
                    }
                });
            });
        },

        setHistoryState: function(rankingType){
            //페이지 최초 진입시 뒤로가기 했을때 2번 클릭해야 뒤로가기됨 수정
            if(sessionStorage.getItem('onceBestRankingDetail') === 'true'){
                void 0;
                history.replaceState('home','', '');
                history.pushState(this.detailHistoryData,'', this.detailUrlStr);
                sessionStorage.setItem('onceBestRankingDetail', 'false');
            }
            /*
            //임시 퍼블용 스크립트 삭제예정
            if(location.host == 'localhost:3010'){
                return;
            }
            ////임시 퍼블용 스크립트 삭제예정
            */
            void 0;
            var self = this;
            var urlStr = "/best-ranking/" + rankingType;
            var superCategoryId = "";
            var categoryId = "";
            var categoryName = "";
            if (vcui.detect.isMobile && rankingType == "present") {
                categoryId = $("#presentCategory_mo option:selected").val();
                categoryName = $("#presentCategory_mo option:selected").text();
            } else {
                superCategoryId = $("input[name="+rankingType+"SuperCategory]:checked").data("categoryid");
                categoryId = $("input[name="+rankingType+"Category]:checked").data("categoryid");
                categoryName = $("input[name="+rankingType+"Category]:checked").data("categoryname");
            }

            var urlParam = new URLSearchParams(location.search);

            if ("todays" == rankingType || "present" == rankingType || "subscribe" == rankingType) {
                if(!vcui.isEmpty(superCategoryId)){
                     urlParam.set("superCategoryId", String(superCategoryId));
                }
                if (!vcui.isEmpty(categoryId)) {
                    urlParam.set("categoryId", String(categoryId));
                    urlParam.set("categoryName", String(categoryName));
                } else {
                    urlParam.delete("superCategoryId");
                    urlParam.delete("categoryId");
                    urlParam.delete("categoryName");
                }
            } else {
                urlParam.delete("superCategoryId");
                urlParam.delete("categoryId");
                urlParam.delete("categoryName");
            }

            if (!vcui.isEmpty(urlParam.toString())) {
                urlStr += "?" + urlParam.toString();
            }

            var historyData = {
                rankingType : rankingType,
                categoryId : categoryId || '',
                categoryHtml : self.saveCacheCategory($("#"+rankingType+"_category_content")),
                filterHtml : self.saveCacheFilter($("#"+rankingType+"_filter_content")),
                contentHtml : $("#"+rankingType+"RankingProduct").parent(".ranking__content").html(),
            };
            self.variable.currentRankingType = rankingType;

            //페이지 최초 진입시 뒤로가기 했을때 2번 클릭해야 뒤로가기됨 수정
            if(sessionStorage.getItem('onceBestRankingDetail') === null){
                void 0;
                this.detailHistoryData = historyData;
                this.detailUrlStr = urlStr;
                sessionStorage.setItem('onceBestRankingDetail', 'true');
            }else{
                void 0;
                history.pushState(historyData,'', urlStr);
            }
        },

        getHistoryState: function(data){
            void 0;
            var self = this;

            if (!vcui.isEmpty(data.rankingType)) {
                void 0;
                void 0;
                var rankingType = data.rankingType;
                self.setCacheCategory($("#"+rankingType+"_category_content"), data.categoryHtml,rankingType)
                $("#"+rankingType+"RankingProduct").parent(".ranking__content").html(data.contentHtml);
                self.setCacheFilter( $("#"+rankingType+"_filter_content"), data.filterHtml);
                $('footer').css('visibility','visible');
                if (!vcui.isEmpty(self.variable.currentRankingType)) {
                    $(".tabs").find("li").removeClass("on");
                    $(".tabs #"+rankingType).addClass("on");

                    $(".filter-tab-list").hide();
                    $("#"+rankingType+"_category_content").show();

                    $(".tab-contents.ranking__content").hide();
                    var index = $("#"+rankingType+"RankingProduct").parent(".ranking__content").index();
                    $(".tab-contents.ranking__content").eq(index).show();

                    $(window).trigger('resize');
                }
                if (rankingType == 'multiple-products') {
                    $('.cate-list').find('input:checked').each(function() {
                        if ($(this).attr("id") != 'chk-all') {
                            bestRanking.variable.selectedPackageCategory.push( $(this).val() );
                        } else {
                            bestRanking.variable.selectedPackageCategory = [];
                        }
                    });

                    if (bestRanking.variable.selectedPackageCategory.length < 1) {
                        $('.cate-list').find('input:first').prop('checked', true);
                        $('.comp').prop('disabled', false);
                    }

                }
                $('#todaysSlide').toggle(rankingType === "todays"); // 히스토리 앞/뒤 전환 시 노출 유무 대응 (show/hide 처리가 click 이벤트에만 걸려있어서 추가) // BTOCSITE-63854

                self.variable.currentRankingType = rankingType;
                self.variable.currentCategoryId = data.categoryId;

            }
            setTimeout(function(){
                self.variable.isHistoryBack = false;
            },2000)
            setTimeout(function(){
              $(window).trigger('scroll');
            },300)

            self.bindEvents();
        },
    };
    $(document).on('ready',function(){
        bestRanking.init();
    });

    window.onpopstate = function(event) {
        void 0;
        var data = history.state;
        if(history.state == 'home'){
            location.href = document.referrer;
        }
        if(data && data.rankingType){
            bestRanking.variable.isHistoryBack = true;
            $('.ui_stickyTab').vcStickyTab('instance').offChange = true;
            bestRanking.getHistoryState(data);
            $('.ui_stickyTab').vcStickyTab('instance').offChange = false;
        }

    };
    
});
/**
 * 가격대 더보기 버튼 클릭시
 * @param rankingType
 */
function changePrice(rankingType) {
    void 0;
    var $select = $('#'+rankingType+'Price').eq(0).vcSelectbox().vcSelectbox('instance');
    if (rankingType == 'multiple-products') {
        $select.sel.selectedIndex($select.sel.selectedIndex() - 1);
    } else {
        $select.sel.selectedIndex($select.sel.selectedIndex() + 1);
    }
}

/**
 * 카테고리 조합 더보기 클릭시
 * @param categoryIds
 */
function changePackageCategory(categoryIds) {
    void 0;
    var categoryIdArr = [];
    categoryIdArr = categoryIds.split(",");

    $('.cate-list').find('input').prop('checked', false);
    categoryIdArr.forEach(function(item) {
        $(".cate-list input[value="+item+"]").prop('checked', true);
    });

    $(".btn.comp").click();
}

function setSessionStorage(type) {

    var mltpPlanEventId = $("#mltpPlanEventId").val();
    var index = $("#mltpPlanEventIndex").val();
    var calcItems = this.getCalcItems(index);
    var modelId;

    var sessionCalcItem = lgkorUI.getStorage(mltpPlanEventId + "_calcItems");
    if ('add' == type) {
        var sessionItemData = JSON.parse(sessionCalcItem);
        if (sessionItemData.length > 0) {
            var resultCalcItems = [];
            calcItems.forEach(function(item, index) {
                var isExist = false;
                // 이미 등록된 제품이 아닐 경우 혜택 계산기에 추가
                sessionItemData.forEach(function (data) {
                    if (data.modelId == item.modelId) {
                        isExist = true;
                    }
                });
                if (!isExist) {
                    sessionItemData.push(item);
                }
            });
            resultCalcItems = sessionItemData;
            lgkorUI.setStorage(mltpPlanEventId + "_calcItems", JSON.stringify(resultCalcItems));
            modelId = resultCalcItems[0].modelId;
        }
    } else {
        lgkorUI.setStorage(mltpPlanEventId + "_calcItems", JSON.stringify(calcItems));
        modelId = calcItems[0].modelId;
    }
    $('#mltplExhibitInfoLayer').vcModal('close');
    setExhibitSesseionStorage();
    location.href = "/benefits/exhibitions/detail-" + mltpPlanEventId + "?model_id=" + modelId;

}

function goToExhibitDetail(index, mltpPlanEventId) {
    var calcItems = this.getCalcItems(index);

    try {
        $("#mltpPlanEventId").val(mltpPlanEventId);
        $("#mltpPlanEventIndex").val(index);
        var sessionCalcItem = lgkorUI.getStorage(mltpPlanEventId + "_calcItems");

        if (vcui.isEmpty(sessionCalcItem)) {
            lgkorUI.setStorage(mltpPlanEventId + "_calcItems", JSON.stringify(calcItems));
            setExhibitSesseionStorage();
            location.href = "/benefits/exhibitions/detail-" + mltpPlanEventId + "?model_id=" + calcItems[0].modelId;
        } else {
            var sessionItemData = JSON.parse(sessionCalcItem);
            if (sessionItemData.length > 0) {

                $('#mltplExhibitInfoLayer').vcModal();
            } else {
                resultCalcItems = calcItems;
                lgkorUI.setStorage(mltpPlanEventId + "_calcItems", JSON.stringify(resultCalcItems));
                setExhibitSesseionStorage();
                location.href = "/benefits/exhibitions/detail-" + mltpPlanEventId + "?model_id=" + calcItems[0].modelId;
            }
        }
    } catch (e) {
        void 0;

    }
}

function getCalcItems(index) {
    var calcItems = [];

    $(".ranking__item--package").eq(index - 1).find(".ranking__item").each(function() {
        var item = {};
        item.id = "calc-" + $(this).data("sku");
        item.sku = $(this).data("sku");
        item.modelName = $(this).data("modelname");
        item.oprice = $(this).data("obsoriginalprice") || 0;
        item.dprice = $(this).data("obsmemberprice") || 0;
        item.tprice = $(this).data("obssellingprice") || 0;
        item.odprice = $(this).data("obsdiscountprice") || 0;
        item.cpprice = $(this).data("obscoupondiscountprice") || 0;
        item.mediumImageAddr = $(this).data("mediumimageaddr");
        item.imageAltText = $(this).data("modeldisplayname");
        item.modelId = $(this).data("modelid");
        item.rtModelSeq = "";
        item.bizType = "PRODUCT";
        item.modelStatusCode = $(this).data("modelstatuscode");
        item.modelComponent = "Y";
        calcItems.push(item);
    });
    return calcItems;
}

function setTextOverflowEtc($el){
    if($el.find('.text-overflow-etc').length == 0){
        $el.wrapInner('<span class="text-overflow-etc">');
    }
    var parentW =  $el.width()
    var etcText = ' &#8230 외';
    var $text = $el.find('.text-overflow-etc');
    $text.data('text',$text.text())
    var arr = $text.text().split('');
    var str = '';
    var preStr = '';
    for(var i=0; i<arr.length; i++){
        preStr = str;
        str += arr[i]
        $text.html(str + etcText);
        if(parentW < $text.width()){
            $text.html(preStr + etcText);
            return;
        }
    }
}

function setExhibitSesseionStorage() {
    lgkorUI.setStorage("enterFromBestRanking", "Y"); // BTOCSITE-96183
    if (vcui.detect.isMobile) {
        lgkorUI.setStorage("enterBestranking", "Y");
    }
}

function sendDataLayer() {
    setProductImpression();
    dataLayer.push({
        'event': 'searchResultOpen'
    });
}

function setProductImpression() {
    $(".ranking__item").find("a").attr("product-impression-display", false);
    $(".ranking__content:visible").find(".ranking__item").find("a").attr("product-impression-display", true);
}